/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useNavigate, useLocation } from 'react-router-dom';
import { isEmpty } from 'lodash';
import moment from 'moment';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import useSnackbar from 'src/hooks/useCustomSnackbar';
import useDashboardHomePath from 'src/hooks/useDashboardHomePath';
// @mui
import {
    Card,
    Typography,
    Stack,
    Box,
    Button,
    Dialog,
    DialogTitle,
    DialogActions,
    Popper,
    Paper,
    Grow,
    MenuList,
    MenuItem,
    Radio,
    Zoom,
    Tooltip,
    ListItem,
    List,
    ListItemAvatar,
    ListItemText,
    useTheme,
    ClickAwayListener,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
// Components
import { fetchMergeTagValueForLeads, fetchMergeTagValueForTreatments } from 'src/redux/slices/mergeTags';
import { initializeFacebookAuthToken } from 'src/redux/slices/whatsapp';
import useWindowSize from 'src/hooks/windowSizeListner';
// Treatment-in-progress hub — the SAME popup the task sidebar's Follow-up opens
// for a TREATMENT_STARTED lead (TaskBodyView). Reused here so the Overview
// "Next step → Open task" button opens it directly.
import CompletedTreatmentHub from 'src/pages/dashboard/tables/AllLeadTable/CompletedTreatmentHub';
import ContactPopupDebugBox from 'src/components/fullScreenPopUps/ContactPopupDebugBox';
import PmsSchedulingStatus from '../../../components/pms/PmsSchedulingStatus';
import usePmsSchedulingScope from '../../../hooks/usePmsSchedulingScope';
import BookedPaymentStatusCard from './BookedPaymentStatusCard';
import { parseApiDateTime } from '../../../utils/parseApiDateTime';
import { parseApiDate } from '../../../utils/taskDateUtils';
import Activities, { getActivityTitle } from './Activities';
import TimelineCallEntry from './TimelineCallEntry';
import { callActorName, isFailedVoiceCall, isTimelineCall } from './timelineCalls';
import JourneyHistory from './JourneyHistory';
import MergeHistoryCard from './MergeHistoryCard';
import TreatmentEditPopover from '../../../pages/dashboard/tables/AllLeadTable/TreatmentEditPopover';
import ClinCheckOverViewTab from '../../../components/clinCheck/ClinCheckOverViewTab';
import { Iconify } from '../../../components';
import { AttendedAppointment } from '../../../components/Attended';
import DemoBlur, { piiTitle } from '../../../components/DemoBlur';
import { CustomAvatar, AssignUserAvatar } from '../../../components/custom-avatar';
import { UnableToContact } from '../../../components/failedToAttendTabs';
import UpcomingAppointmentsOverview from '../../../components/UpcomingAppointmentsOverview';
import RecentNotes from '../../../components/RecentNotes';
import RecentAttachments from '../../../components/RecentAttachments';
import SimilarLeadWarningPopup from './SimilarLeadWarningPopup';
import {
    OpenConsultationPopup,
    OpenAttendedPopup,
    OpenUnAttendedPopup,
} from '../../../components/fullScreenPopUps';
import {
    AssignTaskPopup,
    ArchivedLeadPopUp,
    EditPersonalDetailsPopup,
    AppointmentAssignTaskPopup
} from '../../../components/dialogPopUp';
import { NormalLoading } from '../../../components/loading';
import LeadTemplate from '../../../pages/dashboard/LeadTemplate';
import { FollowUp, AppointmentPage } from '../lead';
import ContactLeadPopupRouter from '../../../components/fullScreenPopUps/ContactLeadPopupRouter';
import OpenContactLeadPopup from '../../../components/fullScreenPopUps/OpenContactLeadPopup';
import { resolveLeadActionPopup, normalizeStatus, ACTION, POPUP } from '../../../utils/leadActionPopupResolver';
import { resolveActiveTreatment } from '../../../utils/activeTreatment';
import { flwBtnStyle } from '../../../styles/NewLeadTableRowStyle';
import {
    TreatmentAndAppointment,
    PersonalDetails,
    PaymentOption,
    MessageAndReminder
} from '../general/app';
import { DentallyPaymentConfirmation, DentallyPendingBookingBanner, DentallyTreatmentAvailabilityWizardStep, DentallyFollowUpConfirmWizardStep, BookingModeToggle, DentallyScopePendingStep } from '../../../components/dentally';
import useDentallyIntegrationScope from '../../../hooks/useDentallyIntegrationScope';
import { PmsAvailabilityWizardStep, PmsBookingConfirmStep } from '../../../components/pms';
import { usePmsBookingSession, PmsBookingRecovery } from '../../../components/pms/usePmsBookingSession.tsx';
import { ReusableSidebar } from '../calendar';
import AttendedAppointmentsOverview from '../../../components/AttendedAppointmentsOverview';
// redux
import { setCurrentTreatmentDataGlobal } from '../../../redux/slices/multiTreatment';
import { getActivities } from '../../../redux/slices/activity';
import { updateSelectedSimilarLeads } from '../../../redux/slices/duplicateLeads';
import { dispatch, useSelector } from '../../../redux/store';
import {
    selectFollowLead,
} from '../../../redux/selectors/leadSelectors';
import {
    clearLead,
    updateSteps,
    updateFollowUpLead,
    updateLeadDetail,
    ConsultationAttended,
    RecordAttended,
    recordUnAttended,
    getLeadReminderData,
    CompleteTreatment,
    followUpSlice,
    deleteTreatment,
    tableLead,
    getAppointment,
    startLoadingData,
    getLeadNotes,
    updateReminder,
    getReminderData,
    getLeadNotesWithFilter,
} from '../../../redux/slices/lead';
import { beginArchiveLead } from '../../../redux/slices/lead/coreThunks';
import { clearPracticeUserData } from '../../../redux/slices/practiceUser';
import { switchPractice } from '../../../redux/slices/practiceTreatmentList';
// §9 MUST FE — V2 task thunks for the upcoming-task strip + row actions.
import { completeTask, reopenTask } from '../../../redux/slices/taskSlice';
import useFeaturePermission from '../../../hooks/useFeaturePermission';
import { setLoader } from '../../../redux/slices/loader';
// utils/constant/hooks
import { getTreatmentDetails, handleSetTreatmentDataGlobal } from '../../../utils/multiTreatmentFlow';
import capitalizeFirstLetter from '../../../utils/capitalizedFunc';
import { getMessage } from '../../../utils/getTasksData';
import { GetPracticeAvatar } from '../../../utils/createAvatar';
import { setRowLeadData } from '../../../utils/getRowLeadData';
import { getAssignees } from '../../../utils/multiAsignees';
import { TAB_HEAD, statuses, JOURNEY_STAGES, getStageIndex, NEXT_STEP_SUGGESTIONS } from '../../../constants/LeadDetailConst';
import { getLeadStatusUi, getLeadStatusChipSx } from '../../../utils/leadStatusUi';
import {
    useArchivedToggle,
    useConsultationAttendToggle,
    useRecordAttendToggle,
    useUnRecordAttendToggle,
    useToggle,
    useResponsive,
    useAssignTaskToggle,
    useAddTreatment,
    useLeadTableHelper,
} from '../../../hooks';
import { localStorageRemoveItem } from '../../../utils/storage-available';
// styles
import { common, grey } from '../../../theme/palette';
import {
    overViewCard,
    overViewDynamicOuterBox,
    paperStyle,
    timeLabel,
    avatarBox,
    avatarInnerBox,
    plusIconBox,
    unassignTypo,
    menuListStyle,
    cancelBtnStyle,
    unassignedBoxStyle,
    messageBox,
    overviewMainBoxStyle,
    overviewLeftLayoutBoxStyle,
    overviewRightLayoutBoxStyle,
    finalTreatmentBoxStyle,
    dotsIconBoxStyle,
    treatmentProgressCard,
    treatmentCardHeader,
    treatmentNameStyle,
    treatmentPriceStyle,
    timelineFilterWrapper,
    timelineFilterChip,
    sectionTitle,
} from '../../../styles/OverView';
import {
    paperMenuItem,
    editDetailMenuItem,
    menuItemIcon,
    overViewMenuItemStyle,
    appointmentCardStyle
} from '../../../styles/LeadDetailView';
import { taskButton, archivedButton, textStyle, assignUserAvatarStyle, assignLengthStyle } from '../../../styles/leadTaskReminder';
import { yesBtnStyleForLoader } from '../../../styles/Common';
import 'swiper/css';
import 'swiper/css/navigation';
import TaskChecklistCard from './TaskChecklistCard';
import AttendedChecklistV2 from './AttendedChecklistV2';

// Helper function to check if a note is an AI note
const parseAINote = (noteContent) => {
    if (!noteContent) return null;
    try {
        const parsed = JSON.parse(noteContent);
        if (parsed && parsed.AI_NOTES === true) {
            return parsed;
        }
    } catch (e) {
        // Not a JSON note, return null
    }
    return null;
};

// Helper function to get display text for notes (handles AI notes)
const getNoteDisplayText = (noteContent) => {
    const aiData = parseAINote(noteContent);
    if (aiData) {
        return '🤖 AI Call Summary - Click to view in lead details';
    }
    return capitalizeFirstLetter(noteContent);
};

// ── Overview activity preview helpers ─────────────────────────────────────
// Mirror the lead-detail Timeline tab look so the preview card stays consistent.
// NOTE: hex literals (not palette tokens) — these colours flow through string
// interpolations like `${color}1F` for soft-tinted backgrounds, which require
// a 6-char hex; theme tokens such as `success.main` won't resolve there.
const OVERVIEW_VERB_CONFIG = {
    created: { icon: 'solar:user-plus-bold', color: '#00A76F' },
    treatment_added: { icon: 'solar:teeth-bold', color: '#078DEE' },
    treatment_started: { icon: 'solar:teeth-bold', color: '#00A76F' },
    lead_treatment_status_transitioned: { icon: 'eva:swap-fill', color: '#FFAB00' },
    note_added: { icon: 'solar:pen-bold', color: '#FF5630' },
    message_sent: { icon: 'ic:round-email', color: '#078DEE' },
    message_failed: { icon: 'ic:round-email', color: '#FF5630' },
    whatsapp_message_sent: { icon: 'ic:baseline-whatsapp', color: '#25D366' },
    whatsapp_message_failed: { icon: 'ic:baseline-whatsapp', color: '#FF5630' },
    appointment_added: { icon: 'solar:calendar-bold', color: '#5119B7' },
    appointment_attended: { icon: 'eva:checkmark-circle-2-fill', color: '#00A76F' },
    appointment_cancelled: { icon: 'eva:close-circle-fill', color: '#919EAB' },
    appointment_rescheduled: { icon: 'solar:calendar-bold', color: '#FFAB00' },
    lead_archived: { icon: 'mdi:archive-outline', color: '#919EAB' },
    lead_payment_initiated: { icon: 'solar:wallet-money-bold', color: '#00A76F' },
    default: { icon: 'solar:bell-bold', color: '#919EAB' },
};

const getOverviewActivityIcon = (act) => {
    const verb = act?.verb;
    if (verb === 'note_added') {
        const noteType = act?.action_object?.note;
        const via = act?.action_object?.contacted_via;
        if (noteType === 'UNABLE_TO_CONTACT') return { icon: 'solar:phone-calling-bold', color: '#FF5630' };
        if (via === 'PHONE') return { icon: 'fluent:call-20-filled', color: '#00A76F' };
        if (via === 'WHATSAPP') return { icon: 'ic:baseline-whatsapp', color: '#25D366' };
        if (via === 'EMAIL') return { icon: 'ic:round-email', color: '#078DEE' };
        if (via === 'SMS') return { icon: 'bi:chat-left-dots-fill', color: '#7635DC' };
        if (noteType === 'FOLLOW_UP') return { icon: 'mdi:clock-time-three-outline', color: '#FFAB00' };
        if (noteType === 'AWAITING_RESPONSE') return { icon: 'mdi:clock-time-three-outline', color: '#078DEE' };
        return { icon: 'solar:pen-bold', color: '#637381' };
    }
    // Calls (desk phone and Twilio): the same icon colours as the Timeline tab (red when nobody spoke).
    if (isTimelineCall(act)) return { icon: 'fluent:call-20-filled', color: isFailedVoiceCall(act) ? '#FF5630' : '#00A76F' };
    if (verb === 'message_sent') {
        const ao = act?.action_object;
        const isAuto = ao?.message_group === 'SYSTEM' || ao?.message_category === 'SEQUENCE_MESSAGE';
        if (isAuto) return { icon: 'mdi:email-fast-outline', color: '#919EAB' };
        return { icon: 'ic:round-email', color: '#078DEE' };
    }
    return OVERVIEW_VERB_CONFIG[verb] || OVERVIEW_VERB_CONFIG.default;
};

const OVERVIEW_ENGAGEMENT_LABELS = {
    delivered: 'Delivered', opened: 'Opens', clicked: 'Clicks', bounced: 'Bounced', unsubscribed: 'Unsubscribed',
};

const getOverviewEmailStatus = (act) => {
    if (act?.verb !== 'message_sent' && act?.verb !== 'message_failed') return null;
    if (act?.action_object?.type !== 'EMAIL') return null;
    if (act?.action_object?.message_category === 'NOTIFICATION') return null;
    if (act.verb === 'message_failed') return { label: 'Failed', color: '#FF5630', icon: 'eva:close-circle-fill' };
    const counts = {};
    (act?.action_object?.sent_messages || []).forEach((sm) => {
        (sm?.event_counts || []).forEach((ec) => {
            if (ec?.event && ec?.count) counts[ec.event] = (counts[ec.event] || 0) + ec.count;
        });
    });
    if (counts.bounced) return { label: 'Bounced', color: '#FF5630', icon: 'solar:close-circle-bold', counts };
    if (counts.unsubscribed) return { label: 'Unsubscribed', color: '#919EAB', icon: 'mdi:bell-off-outline', counts };
    if (counts.clicked) return { label: counts.clicked > 1 ? `${counts.clicked} Clicks` : 'Clicked', color: '#00A76F', icon: 'solar:cursor-bold', counts };
    if (counts.opened) return { label: counts.opened > 1 ? `${counts.opened} Opens` : 'Opened', color: '#3b82f6', icon: 'solar:eye-bold', counts };
    if (counts.delivered) return { label: 'Delivered', color: '#919EAB', icon: 'eva:done-all-fill', counts };
    const isAuto = act?.action_object?.message_group === 'SYSTEM' || act?.action_object?.message_category === 'SEQUENCE_MESSAGE';
    if (isAuto) return { label: 'Auto', color: '#C4CDD5', icon: 'mdi:robot-outline' };
    return { label: 'Sent', color: '#919EAB', icon: 'mdi:check' };
};

const OVERVIEW_WHATSAPP_STATUS = {
    read: { label: 'Read', color: '#078DEE', icon: 'eva:done-all-fill' },
    delivered: { label: 'Delivered', color: '#919EAB', icon: 'eva:done-all-fill' },
    sent: { label: 'Sent', color: '#C4CDD5', icon: 'mdi:check' },
    failed: { label: 'Failed', color: '#FF5630', icon: 'eva:close-fill' },
};

const getOverviewWhatsAppStatus = (act) => {
    if (act?.verb === 'whatsapp_message_failed') return { label: 'Failed', color: '#FF5630', icon: 'eva:close-circle-fill' };
    if (act?.verb !== 'whatsapp_message_sent') return null;
    return OVERVIEW_WHATSAPP_STATUS[act?.action_object?.status || 'sent'] || OVERVIEW_WHATSAPP_STATUS.sent;
};

const buildOverviewStatusTooltip = (status) => {
    if (!status?.counts) return status?.label || '';
    return Object.entries(OVERVIEW_ENGAGEMENT_LABELS)
        .filter(([k]) => status.counts[k])
        .map(([k, label]) => `${status.counts[k]} ${label}`)
        .join(' · ');
};

// Timestamp parsing delegates to parseApiDateTime (src/utils/parseApiDateTime.js),
// which reads the BE's `DD-MM-YYYY HH:mm:ss.ffffffZ` shape as UK local wall-clock
// time (the trailing 'Z' is a misleading literal, not a real UTC marker) — see
// that module's header comment for the full root-cause explanation of the
// "in an hour" BST bug this fixes.
export const formatOverviewActivityTime = (timestamp) => {
    const m = parseApiDateTime(timestamp);
    if (!m) return '';
    const now = moment();
    const diffHours = now.diff(m, 'hours');
    const diffDays = now.diff(m.clone().startOf('day'), 'days');
    if (diffHours < 24 && diffDays === 0) return m.fromNow();
    if (diffDays === 1) return `Yesterday at ${m.format('h:mm a')}`;
    if (diffDays > 1 && diffDays <= 6) return `${m.format('dddd')} at ${m.format('h:mm a')}`;
    if (m.year() === now.year()) return m.format('DD MMM, h:mm a');
    return m.format('DD MMM YYYY, h:mm a');
};


const Overview = ({ leadDetail, activityList, onChangeTab, reloadTaskCounter, LeadNotes, handleMenuItems, setSelectTreatmentData, setOpenContactFromCall, openContactFromCall, autoAction, handleReloadLeads }) => {

    const theme = useTheme();

    const inputRef = useRef();
    const personalDetailPopupRef = useRef();
    const updateReminderRef = useRef();

    // Lead-level soonest-due open task, reported up by TaskChecklistCard.
    // No longer read directly here — treatment-card CTA visibility is now
    // driven per-treatment by suggestionByTreatmentId (see getNextStepSuggestions
    // below), not this single lead-wide value. setNextDueTask is still passed
    // down as TaskChecklistCard's onNextTaskResolved callback contract.
    const [, setNextDueTask] = useState(null);
    // Per-treatment task summary: { [leadTreatmentId]: { total, open, done, nextOpenTask } }
    // Populated by the headless TaskChecklistCard via onTreatmentTaskSummary.
    // Drives task-aware Next Step cards in getNextStepSuggestions.
    const [treatmentTaskSummary, setTreatmentTaskSummary] = useState({});
    // True once TaskChecklistCard's first fetch (or feature-gate early-return) settles.
    // Prevents a flash of wrong NO_OPEN_TASKS cards while treatmentTaskSummary is still {}.
    const [taskSummaryReady, setTaskSummaryReady] = useState(false);
    // Treatment-in-progress hub (mirrors TaskBodyView's openTreatmentHub/hubRow).
    const [openTreatmentHub, setOpenTreatmentHub] = useState(false);
    const [hubRow, setHubRow] = useState(null);

    const navigate = useNavigate();

    const { nearestPastData: nearestPastDataV2, nearestData: nearestDataV2 } = useLeadTableHelper('ConsultantBooked');

    const isLight = theme.palette.mode === 'light';

    const isDesktop = useResponsive('down', 'sm');

    const { practiceId } = useSelector((state) => state.practiceTreatmentList);
    // §9 MUST FE — use shared hook (consistent with the other 4 chokepoint files
    // — AddReminderPopup, AllLeadTable/TaskChecklistField, LeadDetailTasks,
    // LeadTaskReminder). canView is true for {view, manage}.
    const { canView: hasTasksV2 } = useFeaturePermission('tasks-v2');

    const { isLoader } = useSelector((state) => state.loaderReducer);
    const currentTreatmentDataGlobal = useSelector((state) => state.multiTreatment?.currentTreatmentDataGlobal);
    // Read from the canonical /form-deliveries/ slice (Track A.3 migration).
    // The legacy `consentV2` slice still exports an identical state shape, but
    // the FORM_SUBMITTED_RECENT next-step engine needs the data populated by the
    // canonical thunks the new Lead Detail flow now uses.
    const { leadConsentRequests } = useSelector((state) => state.formDeliveries);

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const followLead = useSelector(selectFollowLead);
    const [anchorRef, setAnchorRef] = useState(null);
    const [active, setActive] = useState(0);
    const [reminderId, setReminderID] = useState(0);
    const [reminderData, setReminderData] = useState('');
    const [openSidebar, setOpenSidebar] = useState(false);
    const [validStep, setValidStep] = useState(false);
    const [open, setOpen] = useState(false);
    const [treatmentCon, setTreatmentCon] = useState(false);
    const [cancelTreatment, setCancelTreatment] = useState(false);
    const [markComplete, setMarkComplete] = useState(false);
    const { pathname } = useLocation();
    const location = useLocation();
    const routeData = new URLSearchParams(location.search);
    const searchPractice = routeData.get('practiceId');
    const taskId = routeData.get('taskId');
    const tab = routeData.get('tab');
    const metaData = leadDetail && leadDetail?.lead_metadata;
    const leadSourceMetaData = leadDetail && leadDetail?.lead_source && leadDetail?.lead_source?.metadata;
    const [leadAppointment, setLeadAppointment] = useState('');
    const [bookedLeadAppointment, setBookedLeadAppointment] = useState('');
    const [pastAppointment, setPastAppointment] = useState('');
    const [treatmentData, setTreatmentData] = useState('');
    const [assignees, setAssignees] = useState([]);
    const [openContactWhatsapp, setOpenContactWhatsapp] = useState({ open: false });
    const [dentallySlot, setDentallySlot] = useState(null);
    const [selectedDentallyTreatment, setSelectedDentallyTreatment] = useState(null);
    const [dentallyAssignees, setDentallyAssignees] = useState([]);
    const [followUpConfirmStepState, setFollowUpConfirmStepState] = useState({});
    const [useDentallyFlow, setUseDentallyFlow] = useState(true);
    // PMS scheduling state
    const [pmsSlot, setPmsSlot] = useState(null);
    const pmsBookingSession = usePmsBookingSession();
    const [pmsPractitioner, setPmsPractitioner] = useState(null);
    const [pmsDate, setPmsDate] = useState(null);
    const [pmsDuration, setPmsDuration] = useState(30);
    const [pmsConfirmStepState, setPmsConfirmStepState] = useState({});
    const [leadData, setLeadData] = useState({
        lead_id: '',
        treatment_id: '',
        price: '',
        first_name: '',
        last_name: '',
        status: '',
        treatment_name: '',
        created_at_human: ''
    });
    const [currentTreatmentData, setCurrentTreatmentData] = useState({});

    // ── Debug panel toggle — mirrors FollowUpV2.jsx:254-270 verbatim ──
    // In dev: on by default; opt-out with ?attDebug=0 or localStorage attDebug='0'.
    // In prod: off by default; opt-in with ?attDebug=1 or localStorage attDebug='1'.
    const attDebug =
        new URLSearchParams(window.location.search).get('attDebug') === '1'
        || (typeof window !== 'undefined' && window.localStorage.getItem('attDebug') === '1')
        || (import.meta.env.DEV
            && new URLSearchParams(window.location.search).get('attDebug') !== '0'
            && !(typeof window !== 'undefined' && window.localStorage.getItem('attDebug') === '0'));
    // eslint-disable-next-line react/no-unstable-nested-components
    const dbgSx = (color) => (attDebug ? { outline: `2px dashed ${color}`, outlineOffset: '-2px', position: 'relative' } : null);
    // eslint-disable-next-line react/no-unstable-nested-components, react/prop-types
    const DbgTag = ({ color, label }) => (attDebug ? (
        <Box component="span" sx={{ position: 'absolute', top: 0, left: 0, zIndex: 50, bgcolor: color, color: '#fff', fontSize: '9px', fontWeight: 700, lineHeight: 1.4, px: 0.5, borderBottomRightRadius: 4, letterSpacing: '0.04em', pointerEvents: 'none' }}>{label}</Box>
    ) : null);

    const [treatmentOpen, setTreatmentOpen] = useState(false);
    // No global active treatment (selector retired): views derive a most-recent default
    // locally (pure, no global read) and actions pass their explicit treatment.
    const activeTreatment = resolveActiveTreatment(leadDetail, null);
    const treatmentStatus = activeTreatment?.status;
    const isInvisalignTreatment = () => activeTreatment?.treatment === 'Invisalign';
    const shouldRenderClinCheck = (treatmentStatus === 'CONSULTATION_ATTENDED' || treatmentStatus === 'CONSULTATION_BOOKED') && isInvisalignTreatment();
    const finalTreatmentArray = leadDetail?.lead_treatments
        ?.filter((ele) => ele.status !== 'CLOSED' || leadDetail?.lead_treatments?.length <= 3)
        ?.sort((a, b) => {
            const ma = moment(a.updated_at, 'DD-MM-YYYY HH:mm:ss');
            const mb = moment(b.updated_at, 'DD-MM-YYYY HH:mm:ss');
            return (mb.isValid() ? mb.valueOf() : 0) - (ma.isValid() ? ma.valueOf() : 0);
        });
    // Treatment for the Dentally payment-pending CTA: prefer the active treatment,
    // fall back to the first selectable treatment for safety.
    // Fee-pending ("deposit not paid") is a CRM checkbox, not evidence of a sent payment link or a
    // pending Dentally booking; the only Dentally booking banner is DentallyPendingBookingBanner,
    // which reads the durable deferred-booking intent.
    const {
        isAppointmentBooked,
        attendance,
        followUpLead,
        leadReminder,
        contactLead,
        BookingAttendance,
        markAsComplete,
        upComingData,
        isDentallyBooking,
        taskTableData: {
            limit,
            offset,
            filter,
            assignUser
        },
    } = useSelector((state) => state.lead);
    // Dentally gating — per-practice, not the app-global `dentallyEnabledGlobal`
    // boolean. That flag is seeded from localStorage, carries no practice
    // identity, and is cleared only by the dashboard header, so it can still say
    // "on" for the practice you just left (2026-09-19 gating audit, rows 13-16).
    //   dentallyVisible  – read-only Dentally surfaces for THIS practice.
    //   dentallyCanBook  – write actions (booking wizard, mode toggle).
    //   dentallyPending  – the answer is not knowable yet; show a neutral step
    //                      rather than flashing the CRM booking form.
    const dentallyScope = useDentallyIntegrationScope(practiceId);
    const dentallyVisible = dentallyScope.visible;
    const dentallyCanBook = dentallyScope.visible && dentallyScope.canManage;
    const dentallyPending = dentallyScope.pending;
    const dashboardHomePath = useDashboardHomePath();
    const pmsScope = usePmsSchedulingScope(practiceId);
    const pmsEnabledGlobal = pmsScope.enabled;
    // Keep the owner mounted during uncertain writes; otherwise use native steps only for booking.
    const BookingContactPopup = !pmsBookingSession.canNavigate() || (BookingAttendance && isAppointmentBooked === 'Booking Details' && (!pmsScope.ready || pmsEnabledGlobal) && !dentallyVisible && !dentallyPending)
        ? OpenContactLeadPopup : ContactLeadPopupRouter;
    const { practiceTreatment } = useSelector((state) => state.practiceTreatmentList);
    const anchorTreatmentRef = useRef(null);
    const [anchorElAssign, setAnchorElAssign] = useState(null);
    const [anchorEditTreatment, setAnchorEditTreatment] = useState(null);
    const assigneeData = upComingData?.assignees?.filter((el) => el?.user?.first_name && !el?.user?.is_superuser);
    const [templateOpen, setTemplateOpen] = useState('');
    const [timelineFilter, setTimelineFilter] = useState('All');
    const [width, height] = useWindowSize();

    // V1 attended-checklist helpers removed — surface migrated to AttendedChecklistV2.

    useEffect(() => {
        if (followLead) {
            const treatmentFilter = followLead?.lead_appointment;  // all treatments — widget labels per treatment; no active-treatment scoping
            const upcomingAppointment = treatmentFilter?.filter((el) => (
                moment(el.datetime, 'DD-MM-YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss') > moment().format('YYYY-MM-DD HH:mm:ss')
            ));
            const upcomingAppointmentSorting = upcomingAppointment?.sort((a, b) => new Date(moment(a.datetime, 'DD-MM-YYYY HH:mm:ss').format('YYYY-MM-DD hh:mm:ss')) - new Date(moment(b.datetime, 'DD-MM-YYYY HH:mm:ss').format('YYYY-MM-DD hh:mm:ss')));
            const bookedStatusFilter = upcomingAppointmentSorting?.filter((el) => el.status === 'BOOKED');
            const PastAppointment = treatmentFilter?.filter((el) => el.status === 'ATTENDED');
            const PastAppointmentSorting = PastAppointment?.sort((a, b) => new Date(moment(a.datetime, 'DD-MM-YYYY HH:mm:ss').format('YYYY-MM-DD hh:mm:ss')) - new Date(moment(b.datetime, 'DD-MM-YYYY HH:mm:ss').format('YYYY-MM-DD hh:mm:ss')));
            setLeadAppointment(bookedStatusFilter);
            setBookedLeadAppointment(bookedStatusFilter);
            setPastAppointment(PastAppointmentSorting);
        }
    }, [followLead]);

    const getBtnName = (treatment) => {
        if ((treatment?.lead_contacted_counts?.find(item => item.status === treatment?.status)?.count === 0 || treatment?.lead_contacted_counts?.length === 0) && treatment.status === 'NEW') {
            return leadDetail?.lead_contact?.preferred_contact_method?.toLowerCase() === "whatsapp" ? 'Contact Lead (WhatsApp)' : 'Contact Lead';
        }
        if (leadDetail?.lead_treatments?.length > 0 && statuses.includes(treatment.status)) {
            return 'Follow up';
        }
        switch (treatment.status) {
            case 'CONSULTATION_BOOKED':
                return 'Record Attendance';
            case 'TREATMENT_STARTED':
                return 'Treatment in progress';
            case 'CLOSED':
                return 'Completed';
            default:
                return '';
        }
    };

    const getHtmlElement = () => document.querySelector('body');

    const removeClass = () => {
        const htmlElement = getHtmlElement();
        htmlElement.classList.remove('overflow-hidden');
    };

    const getStatus = (treatment) => TAB_HEAD.map((e1) => {
        let latestData = '';
        if (treatment?.status === e1.value) {
            latestData = e1.label;
        }
        return latestData;
    });

    useEffect(() => {
        dispatch(getAppointment(practiceId, leadDetail?.id));
        dispatch(updateSelectedSimilarLeads({ leadIds: [] }));
    }, []);

    useEffect(() => {
        if (searchPractice && taskId) {
            dispatch(switchPractice(searchPractice));
            // §9 MUST FE — V2 practices skip the V1 reminder fetch; the V2 task
            // slideout is reached via /tasks-v2/<id> (handled elsewhere). V1
            // practices keep the existing /reminders/ flow.
            if (!hasTasksV2) {
                dispatch(getReminderData(searchPractice, taskId));
                setOpenSidebar(true);
            }
        }
    }, [searchPractice, taskId, hasTasksV2]);

    useEffect(() => {
        if (leadDetail?.lead_treatments?.length > 0) {
            // Add-appointment default treatment — most-recently-updated selectable (no global active read).
            setTreatmentData(resolveActiveTreatment(leadDetail, null) || leadDetail?.lead_treatments[0]);
            dispatch(getLeadReminderData(practiceId, 'LeadDetail', 1, 0, '', leadDetail?.id, '', '', 'Graterthan'));
            dispatch(getLeadReminderData(practiceId, 'LeadDetail', 10, 0, 'leadNotes', leadDetail?.id, '', '', '', 'counter'));
        }
    }, [leadDetail, practiceId]);

    useEffect(() => {
        if (upComingData) {
            setReminderData(upComingData);
        }
    }, [upComingData]);

    const {
        toggle: openFollowLead,
        onOpen: onOpenFollowLead,
        onClose: onCloseFollowLead
    } = useToggle();

    // Superadmin debug: which Overview control launched the contact popup.
    const [contactDebugSource, setContactDebugSource] = useState('lead-detail:overview');

    const {
        toggle: leadDetailModal,
        onOpen: onLeadDetail,
        onClose: onCloseLeadDetail
    } = useToggle();

    const {
        toggle: openConsultationAttend,
        onOpen: onOpenConsultationAttend,
        onClose: onCloseConsultationAttend
    } = useConsultationAttendToggle();

    const {
        toggle: openRecordAttend,
        onOpen: onOpenRecordAttend,
        onClose: onCloseRecordAttend
    } = useRecordAttendToggle();

    const [appointmentOutcomeSelection, setAppointmentOutcomeSelection] = useState(null);
    const {
        toggle: openUnRecordAttend,
        onOpen: onOpenUnRecordAttend,
        onClose: onCloseUnRecordAttend
    } = useUnRecordAttendToggle();

    const {
        toggle: openArchiveLead,
        onOpen: onOpenArchiveLead,
        onClose: onCloseArchiveLead
    } = useArchivedToggle();

    const {
        toggle: openAppointmentAssignTask,
        onOpen: onOpenAppointmentAssignTask,
        onClose: onCloseAppointmentAssignTask
    } = useAssignTaskToggle();

    const CreateLeadHeaderData = {
        title: 'Create Lead',
        button1: 'Save & Continue Later',
        button2: 'Close',
    };

    const editDetailHandler = () => onLeadDetail();

    const closeEditDetails = () => onCloseLeadDetail();

    const closeHandler = (value) => {
        setOpenSidebar(false);
        if (value === 'finish') {
            setTreatmentCon(false);
            dispatch(setLoader(false));
            setCancelTreatment(false);
            dispatch(followUpSlice(leadDetail?.id, practiceId, 'LeadDetail'));
            dispatch(getLeadReminderData(practiceId, 'LeadDetail', limit, offset, filter, leadDetail?.id, assignUser));
            reloadTaskCounter({ userId: assignUser, id: leadDetail?.id });
            dispatch(getLeadReminderData(practiceId, 'LeadDetail', 1, 0, '', leadDetail?.id, '', '', 'Graterthan'));
        }
    };

    const onSubmit = (data) => {
        setValidStep(!!data);
    };

    useEffect(() => {
        if (markAsComplete) {
            switch (followUpLead) {
                case 'contactLead':
                    // Clear attendance='payment' before completing so addAppointment falls through
                    // to the clean success path (toast + close) instead of diverting to
                    // updatePersonalDetail when Mark As Complete is used (appointmentThunks.js:66).
                    dispatch(updateSteps(null));
                    dispatch(updateLeadDetail(isAppointmentBooked, handleClose));
                    break;
                case 'consultationAttended':
                    dispatch(ConsultationAttended(handleClose));
                    break;
                case 'recordAttended':
                    dispatch(RecordAttended(handleClose));
                    break;
                case 'recordUnAttended':
                    dispatch(recordUnAttended(handleClose));
                    break;
                default:
                    break;
            }
        }
    }, [markAsComplete, followUpLead]);

    const openAppointmentAssignTaskFuc = (value, assignees, event) => {
        setAnchorElAssign(anchorElAssign ? null : event.currentTarget);
        onOpenAppointmentAssignTask();
        setReminderID(value?.lead_id);
        setAssignees(assignees);
    };

    const onCloseAppointmentAssignTaskPopup = () => onCloseAppointmentAssignTask();

    const handleClose = (status, Archived) => {
        if (!pmsBookingSession.reset()) return;
        dispatch(setLoader(false));
        if (status === 'markComplete') {
            dispatch(getLeadReminderData(practiceId, 'LeadDetail', limit, offset, filter, leadDetail?.id, assignUser, '', 'leadNotes', 'counter'));
            reloadTaskCounter({ userID: assignUser, id: leadDetail?.id });
            dispatch(getLeadReminderData(practiceId, 'LeadDetail', 1, 0, '', leadDetail?.id, '', '', 'Graterthan'));
            setOpenSidebar(false);
        };
        if (status?.toLowerCase?.() === 'finish' && Archived === true) {
            navigate(dashboardHomePath);
            setOpenSidebar(false);
            dispatch(clearLead());
            dispatch(setCurrentTreatmentDataGlobal(null));
            dispatch(updateSteps(null));
            dispatch(updateFollowUpLead(null));
            setAnchorElAssign(null);
            removeClass();
            return;
        };
        if (status?.toLowerCase?.() === 'finish' && updateReminderRef.current) {
            // §9 MUST FE — V2 practices complete through V2 endpoint; V1
            // practices keep the legacy /reminders/ PATCH path.
            if (hasTasksV2) {
                if (upComingData?.id) {
                    dispatch(completeTask(practiceId, upComingData.id, handleReminder));
                }
            } else {
                const data = {
                    datetime: `${moment().format('DD-MM-YYYY HH:mm:ss')}.0Z`,
                    is_completed: true
                };
                dispatch(updateReminder(data, upComingData?.id, practiceId, handleReminder));
            }
            setOpenSidebar(false);
        } else if (status?.toLowerCase?.() === 'finish') {
            handleReminder();
            setOpenSidebar(false);
        };
        dispatch(startLoadingData(false));
        setAnchorRef(null);
        setAnchorElAssign(null);
        setOpen(false);
        setDentallySlot(null);
        setSelectedDentallyTreatment(null);
        setDentallyAssignees([]);
        setPmsSlot(null);
        setPmsPractitioner(null);
        setPmsDate(null);
        setUseDentallyFlow(true);
        setFollowUpConfirmStepState({});
        dispatch(clearLead());
        dispatch(setCurrentTreatmentDataGlobal(null));
        dispatch(updateSteps(null));
        dispatch(updateFollowUpLead(null));
        onCloseFollowLead();
        onCloseConsultationAttend();
        onCloseRecordAttend();
        onCloseUnRecordAttend();
        onCloseArchiveLead();
        // Task mutations broadcast lead-tasks-v2-changed at the point they save;
        // finish flows also emit overview-finish via handleReminder(). A pure
        // popup close should not refetch the task card, timeline, or host table.
        removeClass();
    };

    const STEPS = [
        {
            label: 'Contact',
            component: <FollowUp ref={inputRef} handleNext={onSubmit} handleClose={handleClose} followLeadForScript={followLead} />
        }
    ];

    const [leadStep, setLeadStep] = useState(STEPS);

    useEffect(() => {
        if (contactLead) {
            const STEPS = [
                {
                    label: 'Contact',
                    component: <FollowUp ref={inputRef} handleNext={onSubmit} handleClose={handleClose} />
                }
            ];
            setLeadStep(STEPS);
        } else {
            const STEPS = [
                {
                    label: 'Contact',
                    component: <Activities activityList={activityList} notAllow />
                }
            ];
            setLeadStep(STEPS);
        }
    }, [contactLead]);

    useEffect(() => {
        if (BookingAttendance) {
            const steps = [...STEPS];
            if (isAppointmentBooked === 'Booking Details' && !pmsScope.ready) {
                steps.push({ label: 'Booking settings', component: <PmsSchedulingStatus scope={pmsScope} />, buttonDisabled: true });
                setLeadStep(steps);
                return;
            }
            if (isAppointmentBooked === 'Booking Details' && dentallyPending) {
                // Scope for this practice has not settled. Hold a neutral step so
                // the operator never starts the CRM form and has it replaced by
                // the Dentally wizard (or vice versa) a moment later.
                steps.push({ label: 'Booking Details', component: <DentallyScopePendingStep /> });
                setLeadStep(steps);
                return;
            }
            if (isAppointmentBooked === 'Booking Details' && pmsEnabledGlobal && !dentallyVisible) {
                // PMS path: 2 steps — Availability → Confirm Booking
                steps.push({
                    label: 'Select Appointment',
                    component: (
                        <PmsAvailabilityWizardStep
                            ref={inputRef}
                            handleNext={onSubmit}
                            practiceId={practiceId}
                            leadId={leadDetail?.id}
                            treatmentId={currentTreatmentData?.treatmentData?.id}
                            pmsSlot={pmsSlot}
                            onSlotSelected={setPmsSlot}
                            selectedPractitioner={pmsPractitioner}
                            onPractitionerSelected={setPmsPractitioner}
                            selectedDate={pmsDate}
                            onDateSelected={setPmsDate}
                            appointmentDuration={pmsDuration}
                            onDurationChange={setPmsDuration}
                        />
                    ),
                });
                steps.push({
                    label: 'Confirm Booking',
                    ...pmsConfirmStepState,
                    component: (
                        <PmsBookingConfirmStep
                            {...pmsBookingSession.confirmationProps}
                            ref={inputRef}
                            pmsSlot={pmsSlot}
                            practiceId={practiceId}
                            existingLead={leadDetail ? {
                                id: leadDetail.id,
                                first_name: leadDetail.first_name,
                                last_name: leadDetail.last_name,
                                lead_contact: {
                                    phone: leadDetail.lead_contact?.phone,
                                    email: leadDetail.lead_contact?.email,
                                },
                            } : null}
                            existingTreatmentId={currentTreatmentData?.treatmentData?.id ? Number(currentTreatmentData.treatmentData.id) : null}
                            onClose={(success) => {
                                if (success) {
                                    dispatch(followUpSlice(leadDetail?.id, practiceId, 'LeadDetail'));
                                    handleClose('finish');
                                }
                            }}
                            onStepStateChange={setPmsConfirmStepState}
                            appointmentDuration={pmsDuration}
                        />
                    ),
                });
            } else if (isAppointmentBooked === 'Booking Details' && dentallyCanBook && useDentallyFlow) {
                // Dentally path: 2 steps — Treatment & Availability → Confirm Booking
                steps.push({
                    label: 'Treatment & Availability',
                    component: (
                        <Box>
                            <BookingModeToggle useDentally onChange={handleToggleBookingMode} />
                            <DentallyTreatmentAvailabilityWizardStep
                                ref={inputRef}
                                handleNext={onSubmit}
                                practiceId={practiceId}
                                dentallySlot={dentallySlot}
                                onSlotSelected={setDentallySlot}
                                selectedDentallyTreatment={selectedDentallyTreatment}
                                onTreatmentSelected={setSelectedDentallyTreatment}
                                assignees={dentallyAssignees}
                                onAssigneesChanged={setDentallyAssignees}
                            />
                        </Box>
                    ),
                });
                steps.push({
                    label: 'Confirm Booking',
                    ...followUpConfirmStepState,
                    component: (
                        <DentallyFollowUpConfirmWizardStep
                            ref={inputRef}
                            selectedSlot={dentallySlot}
                            selectedDentallyTreatment={selectedDentallyTreatment}
                            assignees={dentallyAssignees}
                            practiceId={practiceId}
                            existingLead={leadDetail ? {
                                id: leadDetail.id,
                                first_name: leadDetail.first_name,
                                last_name: leadDetail.last_name,
                                lead_contact: {
                                    phone: leadDetail.lead_contact?.phone,
                                    email: leadDetail.lead_contact?.email,
                                },
                                dob: leadDetail.dob,
                                salutation: leadDetail.salutation,
                                sex: leadDetail.sex,
                                nhs_number: leadDetail.nhs_number,
                                emergency_contact_name: leadDetail.emergency_contact_name,
                                emergency_contact_phone: leadDetail.emergency_contact_phone,
                            } : null}
                            existingTreatmentId={currentTreatmentData?.treatmentData?.id ? Number(currentTreatmentData.treatmentData.id) : null}
                            onClose={(success) => {
                                if (success) {
                                    // Refresh lead data so the pending booking banner appears immediately
                                    dispatch(followUpSlice(leadDetail?.id, practiceId, 'LeadDetail'));
                                    handleClose('finish');
                                }
                            }}
                            onStepStateChange={setFollowUpConfirmStepState}
                        />
                    ),
                });
            } else {
                steps.push({
                    label: isAppointmentBooked,
                    component: isAppointmentBooked === 'Booking Details'
                        ? <Box>
                            {dentallyCanBook && <BookingModeToggle useDentally={false} onChange={handleToggleBookingMode} />}
                            <TreatmentAndAppointment ref={inputRef} type={'followUp'} handleNext={onSubmit} isOverview />
                        </Box>
                        : isAppointmentBooked === 'Unable to contact' ?
                            <UnableToContact ref={inputRef} handleNext={onSubmit} isOverview completeFlow={handleClose} />
                            : <AppointmentPage ref={inputRef} handleNext={onSubmit} />
                });
            }
            setLeadStep(steps);
            return;
        }
        setLeadStep(STEPS);
    }, [pmsScope.ready, pmsScope.error, pmsScope.retry, pmsEnabledGlobal, BookingAttendance, dentallySlot, selectedDentallyTreatment, dentallyAssignees, followLead, followUpConfirmStepState, useDentallyFlow, pmsSlot, pmsPractitioner, pmsDate, pmsDuration, pmsConfirmStepState, pmsBookingSession.status, leadDetail?.id, currentTreatmentData?.treatmentData?.id, dentallyVisible, dentallyCanBook, dentallyPending]);

    useEffect(() => {
        if (attendance && isAppointmentBooked !== 'Appointment Not Booked') {
            const steps = [...STEPS];
            if (attendance === 'attendance') {
                steps.push({
                    label: isAppointmentBooked,
                    component: isAppointmentBooked === 'Booking Details'
                        ? <TreatmentAndAppointment ref={inputRef} type={'followUp'} handleNext={onSubmit} isOverview />
                        : isAppointmentBooked === 'Unable to contact' ?
                            <UnableToContact ref={inputRef} handleNext={onSubmit} isOverview completeFlow={handleClose} />
                            : <AppointmentPage ref={inputRef} handleNext={onSubmit} />
                });
                steps.push({
                    label: 'Appointment Outcome',
                    component: <AttendedAppointment ref={inputRef} handleNext={onSubmit} isOverview />
                });
            } else {
                steps.push({
                    label: isAppointmentBooked,
                    component: isAppointmentBooked === 'Booking Details'
                        ? <TreatmentAndAppointment ref={inputRef} type={'followUp'} handleNext={onSubmit} isOverview />
                        : isAppointmentBooked === 'Unable to contact' ?
                            <UnableToContact ref={inputRef} handleNext={onSubmit} isOverview completeFlow={handleClose} />
                            : <AppointmentPage ref={inputRef} handleNext={onSubmit} />
                });
                steps.push({
                    label: 'Personal Details',
                    component: <PersonalDetails ref={inputRef} handleNext={onSubmit} />
                });
                steps.push({
                    label: 'Payment options',
                    component: <PaymentOption ref={inputRef} handleNext={onSubmit} />
                });
                if (dentallyVisible && isDentallyBooking) {
                    steps.push({
                        label: 'Dentally Confirmation',
                        component: <DentallyPaymentConfirmation ref={inputRef} handleNext={onSubmit} />
                    });
                }
                steps.push({
                    label: 'Message review & reminders',
                    component: <MessageAndReminder ref={inputRef} handleNext={onSubmit} type={'CreatLead'} />
                });
            }
            setLeadStep(steps);
        } else {
            setLeadStep(STEPS);
        }
    }, [attendance, isDentallyBooking, dentallyVisible]);

    useEffect(() => {
        if (!followUpLead) {
            handleClose();
            dispatch(updateSteps(null));
        }
    }, [followUpLead]);

    // Auto-trigger workflow action from command palette or navigation state
    const autoActionProcessedRef = useRef(false);
    useEffect(() => {
        if (!autoAction || !leadDetail?.id || !leadDetail?.lead_treatments?.length || autoActionProcessedRef.current) return;
        autoActionProcessedRef.current = true;

        const treatment = activeTreatment || leadDetail.lead_treatments[0];
        // Small delay to ensure component is fully mounted and dialogs are ready
        const timer = setTimeout(() => {
            switch (autoAction) {
                case 'bookConsultation':
                    btnHandler(null, '', treatment);
                    break;
                case 'markAttended':
                    handleSetTreatmentDataGlobal({ leadDetail, treatment, setCurrentTreatmentData });
                    getLeadData();
                    dispatch(updateFollowUpLead('recordAttended'));
                    onOpenRecordAttend();
                    break;
                case 'markFTA':
                    handleSetTreatmentDataGlobal({ leadDetail, treatment, setCurrentTreatmentData });
                    getLeadData();
                    dispatch(updateFollowUpLead('recordUnAttended'));
                    onOpenUnRecordAttend();
                    break;
                case 'startTreatment': {
                    // F: open the contextual start flow for the startable treatment via the
                    // existing btnHandler path — NOT the Complete dialog (setTreatmentCon).
                    const startable = finalTreatmentArray?.find((t) => t.status === 'CONSULTATION_ATTENDED') || finalTreatmentArray?.[0];
                    btnHandler('', '', startable);
                    break;
                }
                case 'completeTreatment':
                    setTreatmentCon(true);
                    break;
                default:
                    break;
            }
        }, 500);
        return () => clearTimeout(timer);
    }, [autoAction, leadDetail]);

    const getLeadData = () => {
        dispatch(followUpSlice(leadDetail?.id, practiceId));
        setTimeout(() => {
            dispatch(getAppointment(practiceId, leadDetail?.id));
        }, 800);
    };

    const btnHandler = (event, value, treatment, isCallScript) => {
        // Superadmin debug: identify which Overview control invoked btnHandler.
        // `event === 'called'` → the primary Follow Up / call CTA;
        // `isCallScript` → the call-script auto-action path;
        // an actual MouseEvent (object) → the per-treatment action button.
        const overviewBtn = isCallScript
            ? 'call-script-action'
            : event === 'called'
                ? 'followup-cta'
                : (event && typeof event === 'object')
                    ? 'treatment-action-btn'
                    : 'treatment-cta';
        setContactDebugSource(`lead-detail:overview→${overviewBtn}`);
        if (leadDetail?.lead_contact?.preferred_contact_method?.toLowerCase() === "whatsapp") {
            dispatch(initializeFacebookAuthToken());
            setOpenContactWhatsapp({ open: true, treatmentCallBack: () => { } });
        }
        localStorageRemoveItem('localTreatmentData');
        if (event === 'called') {
            updateReminderRef.current = true;
        }
        tableData();
        dispatch(fetchMergeTagValueForLeads(leadDetail?.id));
        dispatch(fetchMergeTagValueForTreatments(leadDetail?.id, getTreatmentDetails('id', treatment, leadDetail) || null));
        setLeadData({
            lead_id: leadDetail?.id || '',
            treatment_id: getTreatmentDetails('id', treatment, leadDetail),
            price: getTreatmentDetails('price', treatment, leadDetail),
            first_name: leadDetail.first_name || '',
            last_name: leadDetail.last_name || '',
            status: getTreatmentDetails('status', treatment, leadDetail),
            treatment_name: getTreatmentDetails('treatment', treatment, leadDetail),
            lead_treatments__lead_contacted_counts__count: getTreatmentDetails('count', treatment, leadDetail) === 0 && isCallScript ? null : getTreatmentDetails('count', treatment, leadDetail),
            clinCheckData: getTreatmentDetails('clinCheck', treatment, leadDetail),
            treatmentData: leadDetail?.lead_treatments
        });
        let STATUS = getTreatmentDetails('status', treatment, leadDetail);
        if (treatment) {
            const payload = {
                lead_id: leadDetail?.id || '',
                first_name: leadDetail.first_name || '',
                last_name: leadDetail.last_name || '',
                treatmentData: treatment
            };
            setCurrentTreatmentData(payload);
            dispatch(setCurrentTreatmentDataGlobal(payload));
        } else {
            setCurrentTreatmentData({});
            dispatch(setCurrentTreatmentDataGlobal(null));
        }
        if (value === 'Archive') {
            // Open the popup. The sentinel (updateFollowUpLead + markAsComplete) is NOT
            // used for this path — ArchivedLeadPopUp passes onExplicitArchiveSubmit
            // straight to Archive, which calls beginArchiveLead directly on submit.
            onOpenArchiveLead(leadDetail?.id);
            return;
        }
        if (isCallScript) {
            STATUS = 'NEW'; // Setting to new as default beaviour of outbound for call script
        }
        // Route via the shared resolver instead of a local status switch, so this
        // CTA opens the same logical popup as every other fire point for a given
        // status (popup-routing-consolidation Phase 3). The resolver owns status
        // classification + aliases; this call site keeps the side-effects and the
        // concrete Attended-popup split (record-attendance vs consultation view),
        // which is a Phase 4 concern.
        const normalizedStatus = normalizeStatus(STATUS);
        // The Overview "advance" CTA on a booked lead means "record attendance",
        // so declare RECORD_ATTENDED intent to preserve today's behaviour (the
        // AttendanceGate inside the Attended popup then handles Attended/FTA).
        const advanceAction = normalizedStatus === 'CONSULTATION_BOOKED' ? ACTION.RECORD_ATTENDED : undefined;
        const { popup } = resolveLeadActionPopup({
            status: STATUS,
            action: advanceAction,
            practiceId,
            leadId: leadDetail?.id,
            leadTreatmentId: getTreatmentDetails('id', treatment, leadDetail),
            source: 'lead-detail:overview',
        });
        switch (popup) {
            case POPUP.FOLLOW_UP: {
                // The previous switch only opened the contact popup for a literal
                // 'NEW' status; unknown/empty statuses (e.g. a lead with no
                // hydrated treatment) fell through to `default: break` — a no-op.
                // The resolver maps unknown/empty → FOLLOW_UP, so guard on the raw
                // status to preserve that original no-op rather than open a popup.
                if (STATUS !== 'NEW') break;
                dispatch(updateFollowUpLead('contactLead'));
                dispatch(followUpSlice(leadDetail?.id, practiceId));
                setContactDebugSource((prev) => `${prev}(status=NEW)`);
                const htmlElement = getHtmlElement();
                htmlElement.classList.add('overflow-hidden');
                onOpenFollowLead();
                return;
            }
            case POPUP.ATTENDED:
                if (normalizedStatus === 'CONSULTATION_BOOKED') {
                    // Booked → record attendance. The reminder-completion path
                    // (event==='called') is already handled at the top of btnHandler.
                    handleSetTreatmentDataGlobal({ leadDetail, treatment, setCurrentTreatmentData });
                    getLeadData();
                    dispatch(updateFollowUpLead('recordAttended'));
                    onOpenRecordAttend();
                } else {
                    // Already attended → consultation / attended checklist view.
                    dispatch(updateFollowUpLead('consultationAttended'));
                    getLeadData();
                    onOpenConsultationAttend();
                }
                return;
            case POPUP.FTA:
                getLeadData();
                handleAttenedFailedClick();
                return;
            case POPUP.TREATMENT_STARTED: {
                const lt = treatment;
                document.querySelector('body')?.classList.add('overflow-hidden');
                setHubRow({
                    lead_id: leadDetail?.id,
                    id: leadDetail?.id,
                    first_name: leadDetail?.first_name || '',
                    last_name: leadDetail?.last_name || '',
                    status: 'TREATMENT_STARTED',
                    treatment_id: lt?.id,
                    treatment_name: lt?.treatment || lt?.treatment_name || '',
                    price: lt?.price || lt?.custom_price || '',
                    treatmentData: lt ? [lt] : [],
                });
                setOpenTreatmentHub(true);
                break;
            }
            // READ_ONLY (CLOSED/ARCHIVED) and any unmapped popup: no-op, matching
            // the previous switch's default branch.
            default:
                break;
        }
    };

    const handleReminder = () => {
        dispatch(followUpSlice(leadDetail?.id, practiceId, 'LeadDetail'));
        dispatch(getLeadNotes(leadDetail?.id, practiceId, handleSuccess));
        dispatch(getLeadNotesWithFilter(leadDetail?.id, practiceId, handleSuccess));
        dispatch(getActivities(practiceId, leadDetail.id, 10, 0));
        dispatch(getLeadReminderData(practiceId, 'LeadDetail', limit, offset, filter, leadDetail?.id, assignUser, '', '', 'counter'));
        reloadTaskCounter({ id: leadDetail?.id });
        dispatch(getLeadReminderData(practiceId, 'LeadDetail', 1, 0, '', leadDetail?.id, '', '', 'Graterthan'));
        // Refresh the V2 task checklist card (next-step suggestion) AND the Tasks
        // tab badge after a popup finish — TaskChecklistCard + LeadDetailViewBody
        // both listen for this. reloadTaskCounter alone updates the badge but not
        // the next-step card, so the Overview showed a stale "next task".
        window.dispatchEvent(new CustomEvent('lead-tasks-v2-changed', { detail: { source: 'overview-finish' } }));
    };

    const getCurrentTreatmentData = () => {
        if (!isEmpty(currentTreatmentData?.treatmentData)) {
            return currentTreatmentData?.treatmentData;
        }
        return activeTreatment || leadDetail?.lead_treatments?.[0];
    };

    const apiHandler = () => {
        if (treatmentCon) {
            const data = {
                treatment: getCurrentTreatmentData()?.treatment || '',
                custom_price: getCurrentTreatmentData()?.price || ''
            };
            dispatch(setLoader(true));
            dispatch(CompleteTreatment(data, getCurrentTreatmentData()?.lead, getCurrentTreatmentData()?.id, practiceId, closeHandler));
        }
        if (cancelTreatment && leadDetail?.lead_treatments?.length > 0) {
            dispatch(deleteTreatment(practiceId, leadDetail.id, getCurrentTreatmentData()?.id, handleSuccess));
        }
    };

    const handleSuccess = (data) => {
        if (data?.cancelTreatment) {
            enqueueSnackbar(data.message || '', {
                variant: data.success ? 'success' : 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                }
            });
            closeHandler();
            dispatch(getLeadReminderData(practiceId, 'LeadDetail', 10, 0, '', leadDetail?.id, ''));
            reloadTaskCounter({ id: leadDetail?.id });
            dispatch(getLeadReminderData(practiceId, 'LeadDetail', 1, 0, '', leadDetail?.id, '', '', 'Graterthan'));
            dispatch(getActivities(practiceId, leadDetail?.id, 10, 0));
            setCancelTreatment(false);
        }
        if (data.message === 'Task completed !') {
            setMarkComplete(false);
            const key = enqueueSnackbar(data.message || '', {
                variant: data.success ? 'success' : 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                },
                autoHideDuration: 5000,
                action:
                    <>
                        <Button onClick={() => undoReminder()} variant='success' size='small' sx={{ color: common.mintyZest, '&:hover': { bgcolor: 'rgba(84, 214, 44, 0.16)' } }}>
                            Undo
                        </Button>
                        <Iconify onClick={() => closeSnackbar(key)} icon={'radix-icons:cross-2'} height={15} width={15} sx={{ margin: '0px 8px', cursor: 'pointer' }} />
                    </>
            });
        }
    };

    const undoReminder = () => {
        setMarkComplete(false);
        // §9 MUST FE — V2 reopen via /tasks/<id>/reopen/; V1 keeps PATCH /reminders/.
        if (hasTasksV2) {
            if (upComingData?.id) {
                dispatch(reopenTask(practiceId, upComingData.id, handleClose));
            }
        } else {
            const data = { is_completed: false };
            dispatch(updateReminder(data, upComingData?.id, practiceId, handleClose, 'markComplete'));
        }
        closeSnackbar();
    };

    const buttonHandleClose = (event) => {
        if (anchorRef?.current && anchorRef?.current?.contains(event?.target)) {
            return;
        }
        setOpen(false);
    };

    const tableData = () => {
        const treatment = activeTreatment || leadDetail?.lead_treatments?.[0];
        dispatch(tableLead({
            lead_id: leadDetail?.id || '',
            treatment_id: treatment?.id || '',
            price: treatment?.price || '',
            first_name: leadDetail.first_name || '',
            last_name: leadDetail.last_name || '',
            status: treatment?.status || '',
            treatment_name: treatment?.treatment || '',
            lead_treatments__lead_contacted_counts__count: treatment?.lead_contacted_counts?.find(item => item.status === treatment?.status)?.count || 0,
            treatmentData: leadDetail?.lead_treatments
        }));
    };

    const handleAttenedFailedClick = (id, reminder) => {
        if (reminder) {
            setLeadData({ ...setRowLeadData(reminder, leadData), lead_id: reminder?.lead_treatment?.lead || id || '' });
        }
        handleSetTreatmentDataGlobal({ leadDetail, treatment: reminder, setCurrentTreatmentData });
        getLeadData();
        dispatch(updateFollowUpLead('recordUnAttended'));
        onOpenUnRecordAttend();
    };

    const handleAttenedClick = (data, treatment) => {
        setLeadData({
            lead_id: leadDetail?.id || '',
            treatment_id: treatment?.lead_treatment?.id,
            price: treatment?.lead_treatment?.price,
            first_name: treatment?.lead?.first_name || '',
            last_name: treatment?.lead?.last_name || '',
            status: treatment?.lead_treatment?.status,
            treatment_name: treatment?.lead_treatment?.treatment,
            lead_treatments__lead_contacted_counts__count: treatment?.lead_treatment?.lead_contacted_counts?.find(item => item.status === treatment?.lead_treatment?.status)?.count || 0,
            clinCheckData: treatment?.lead_treatment?.leadtreatment_clincheck,
            treatmentData: leadDetail?.lead_treatments
        });
        handleSetTreatmentDataGlobal({ leadDetail, treatment, setCurrentTreatmentData });
        getLeadData();
        dispatch(updateFollowUpLead('recordAttended'));
        onOpenRecordAttend();
    };

    const popupClose = (status) => {
        setTreatmentCon(false);
        setCancelTreatment(false);
        onCloseAssignTask();
        setAnchorElAssign(null);
        if (status) {
            dispatch(getLeadReminderData(practiceId, 'LeadDetail', 1, 0, '', leadDetail?.id, '', '', 'Graterthan'));
            dispatch(getLeadReminderData(practiceId, 'LeadDetail', 10, 0, 'leadNotes', leadDetail?.id, ''));
        }
    };

    const {
        toggle: openAssignTask,
        onOpen: onOpenAssignTask,
        onClose: onCloseAssignTask
    } = useAssignTaskToggle();

    const OpenAssignTask = (value, event) => {
        setAnchorElAssign(anchorElAssign ? null : event.currentTarget);
        setReminderID(value);
        onOpenAssignTask();
    };

    const markCompleteBtn = (value) => {
        setMarkComplete(value);
        // §9 MUST FE — V2 practices complete via /tasks/<id>/complete/.
        if (hasTasksV2) {
            dispatch(completeTask(practiceId, value, (res) => {
                handleClose(res);
                if (handleSuccess) handleSuccess(res);
            }));
        } else {
            const data = { is_completed: true };
            dispatch(updateReminder(data, value, practiceId, handleClose, 'markComplete', handleSuccess));
        }
    };

    const getReminderBtn = (status, leadTreatment, archive) => {
        if (archive) {
            return <Button
                variant='contained'
                disabled
                sx={archivedButton}
            >
                Archived
            </Button>;
        }
        if (!leadTreatment || status === 'CLOSED') {
            return '';
        }
        const isLeadDataReady = Boolean(followLead?.lead_treatments?.length);
        switch (status) {
            case 'TREATMENT_STARTED':
                return <Button
                    variant='contained'
                    color='primary'
                    disabled={!isLeadDataReady}
                    onClick={() => btnHandler('called', '', leadTreatment)}
                    sx={taskButton}
                >
                    Complete treatment
                </Button>;
            default:
                return <Button
                    variant='contained'
                    color='primary'
                    startIcon={<Iconify icon={'fluent:call-32-filled'} height={15} width={15} />}
                    disabled={!isLeadDataReady}
                    onClick={() => btnHandler('called', '', leadTreatment)}
                    sx={taskButton}
                >
                    Follow Up
                </Button>;
        }
    };

    const sidebarHandler = (data) => {
        setReminderData(data);
        setOpenSidebar(true);
        const tabQuery = tab?.length > 0 ? `&tab=${tab}` : '';
        navigate(`?practiceId=${practiceId}&taskId=${data.id}${tabQuery}`);
    };

    const sidebarCloser = () => {
        setOpenSidebar(false);
        const tabQuery = tab?.length > 0 ? `?tab=${tab}` : '';
        navigate(`${pathname}${tabQuery}`, { replace: true });
        setReminderData('');
    };

    const handleArchivedClose = () => {
        onCloseArchiveLead();
        if (openFollowLead) {
            dispatch(updateFollowUpLead('contactLead'));
        }
    };

    const handleExplicitArchiveSubmit = async ({ data, openCommunication }) => {
        const archiveLeadId = leadData?.lead_id || leadDetail?.id;
        const archiveTreatmentId = leadData?.treatment_id || (activeTreatment || leadDetail?.lead_treatments?.[0])?.id || null;
        if (!archiveLeadId || !practiceId) {
            enqueueSnackbar('Cannot archive: lead not identified. Please close and reopen.', { variant: 'error' });
            return null;
        }

        await dispatch(beginArchiveLead({
            leadId: archiveLeadId,
            practiceId,
            leadTreatmentId: archiveTreatmentId,
            reason: data?.archiveReason || '',
            note: data?.archiveNotes || '',
            isOpenForCommunication: openCommunication?.is_open_for_communication,
            source: 'lead-detail:overview',
            handleClose,
        }));
        return null;
    };

    const {
        toggle: EditTreatment,
        onOpen: onEditTreatment,
        onClose: onCloseEditTreatment
    } = useAddTreatment();

    const handleAddTreatment = (event) => {
        onEditTreatment();
        setAnchorEditTreatment(event.currentTarget);
    };

    const handleTogglePopper = (id, ele) => {
        anchorTreatmentRef.current = document.getElementById(`button-${ele.id}`);
        setTreatmentOpen((prevStates) => ({
            ...prevStates,
            [id]: !prevStates[id],
        }));
    };

    const isPopperOpen = (id) => Boolean(treatmentOpen[id]);

    const handleClickEditTreatment = (ele) => { onChangeTab('', 'Treatments'); setSelectTreatmentData(ele); };

    // ─── Next Step Suggestion Engine ───
    // Returns one suggestion object per treatment in finalTreatmentArray.
    // Per-treatment task-aware Next Step suggestions.
    // Priority per treatment:
    //   1. CLOSED → compact "Completed" done card.
    //   2. Treatment HAS tasks (via treatmentTaskSummary):
    //      a. open > 0 → real task card (soonest-due open task).
    //      b. open === 0 → compact "All tasks complete" done card.
    //      (no status-based suggestion when tasks exist)
    //   3. No tasks → status-based fallback + FORM_SUBMITTED_RECENT on [0].
    // Returns [] when every suggestion is a done card (CLOSED-only / all-done).
    const getNextStepSuggestions = () => {
        if (!finalTreatmentArray?.length) return [];

        // ── Lead-level helpers ──
        const consentRequests = leadConsentRequests?.results || [];
        const parseConsentDate = (ds) => {
            if (!ds) return null;
            const m = moment(ds, 'DD-MM-YYYY HH:mm:ss');
            return m.isValid() ? m : moment(ds);
        };
        const recentSubmission = consentRequests.find((r) => {
            if (r.status !== 'SUBMITTED' || !r.submitted_at) return false;
            const parsed = parseConsentDate(r.submitted_at);
            if (!parsed || !parsed.isValid()) return false;
            return (Date.now() - parsed.valueOf()) / 3600000 <= 24;
        });

        // Merge '_unscoped' tasks (no linked treatment) into finalTreatmentArray[0]
        // (most-recently-updated treatment). Lead-level tasks are attributed there.
        // Active custom/unscoped tasks MUST keep the OPEN_TASK branch alive even
        // when the primary treatment has a paused checklist — open always wins over
        // paused, and paused context is surfaced as a message on the OPEN_TASK card
        // rather than suppressed. Full merge is therefore correct here.
        const effectiveSummary = { ...treatmentTaskSummary };
        if (effectiveSummary._unscoped && finalTreatmentArray.length > 0) {
            const firstId = String(finalTreatmentArray[0].id);
            const u = effectiveSummary._unscoped;
            const ex = effectiveSummary[firstId];
            if (ex) {
                // Full merge: include open counts from unscoped so active custom tasks
                // are never hidden by a paused treatment checklist.
                let nextOpen = ex.nextOpenTask;
                if (u.nextOpenTask && (!nextOpen || new Date(parseApiDateTime(u.nextOpenTask.due_at)) < new Date(parseApiDateTime(nextOpen.due_at)))) {
                    nextOpen = u.nextOpenTask;
                }
                const earliestPaused = ex.pausedUntil && u.pausedUntil
                    ? (new Date(ex.pausedUntil) <= new Date(u.pausedUntil) ? ex.pausedUntil : u.pausedUntil)
                    : (ex.pausedUntil || u.pausedUntil);
                effectiveSummary[firstId] = {
                    total: ex.total + u.total,
                    open: ex.open + u.open,
                    done: ex.done + u.done,
                    paused: (ex.paused || 0) + (u.paused || 0),
                    pausedUntil: earliestPaused,
                    nextOpenTask: nextOpen,
                    // Item-level work/touchpoint signals — OR for booleans, sum for counts.
                    hasPausedWork: (ex.hasPausedWork || false) || (u.hasPausedWork || false),
                    hasPausedTouchpoints: (ex.hasPausedTouchpoints || false) || (u.hasPausedTouchpoints || false),
                    _workCount: (ex._workCount || 0) + (u._workCount || 0),
                    _workDoneCount: (ex._workDoneCount || 0) + (u._workDoneCount || 0),
                };
            } else {
                effectiveSummary[firstId] = u;
            }
            delete effectiveSummary._unscoped;
        }

        const suggestions = finalTreatmentArray.map((treatment, idx) => {
            const { status } = treatment;
            const isFirst = idx === 0;

            // 1. CLOSED → compact done card.
            // "Cancel treatment" and "Complete treatment" both land on CLOSED,
            // so a flat 'Completed' told reception a patient who walked away had
            // finished their treatment. That got louder once cancelling stopped
            // hard-deleting the row: cancel a patient's ONLY treatment and the
            // card now stays on screen instead of vanishing. So show the reason
            // the closer actually gave (FSM StateLog.description) and keep
            // 'Completed' only when there isn't one.
            if (status === 'CLOSED') {
                const closeLog = [...(treatment.state_transition_logs || [])]
                    .filter((l) => l?.state === 'CLOSED' && (l?.description || '').trim())
                    .sort((a, b) => String(b?.timestamp || '').localeCompare(String(a?.timestamp || '')))[0];
                const reason = (closeLog?.description || '').trim();
                const label = (!reason || reason === 'Treatment closed')
                    ? 'Completed'
                    : (reason.length > 32 ? `${reason.slice(0, 31)}…` : reason);
                return { type: 'DONE', _done: true, _doneLabel: label, treatment };
            }

            // 2. FORM_SUBMITTED_RECENT — real actionable signal, takes priority over tasks on [0]
            if (isFirst && recentSubmission) {
                const formName = recentSubmission.form_name || recentSubmission.form?.name || 'Form';
                const submittedMoment = parseConsentDate(recentSubmission.submitted_at);
                const timeAgo = submittedMoment ? submittedMoment.fromNow() : '';
                return {
                    type: 'OPEN_TASK',
                    ...NEXT_STEP_SUGGESTIONS.FORM_SUBMITTED_RECENT,
                    message: NEXT_STEP_SUGGESTIONS.FORM_SUBMITTED_RECENT.getMessage(formName, timeAgo),
                    treatment,
                    submission: recentSubmission,
                };
            }

            // 3. Task-aware: treatment has checklist tasks — drive from them, not status.
            // Priority within task-aware: open > paused > done (all-complete).
            //
            // KEY RULE: open > 0 ALWAYS wins — even when a checklist is also paused.
            // Paused is context (surfaced in the message), not a routing change.
            // Active custom/unscoped tasks are included via the _unscoped merge above,
            // so a paused checklist never hides an available custom task.
            //
            // PAUSED card only when open === 0 (genuinely no actionable work left).
            const summary = effectiveSummary[String(treatment.id)];
            const ui = getLeadStatusUi(status);
            // Label parity with the treatment card's own button: getBtnName()
            // special-cases a never-contacted NEW lead ("Contact Lead" /
            // "Contact Lead (WhatsApp)") — a more specific label than the
            // generic ui.actionLabel ("Follow up"). Every no_task_cta
            // suggestion below (PAUSED / COMPLETE_FOLLOWUP / NO_OPEN_TASKS)
            // uses this so the Next-step CTA text matches what btnHandler
            // actually does for this treatment.
            const noTaskCtaLabel = getBtnName(treatment) || ui.actionLabel;
            if (summary && summary.total > 0) {
                if (summary.open > 0) {
                    // Open task exists — this treatment has actionable work.
                    // If a checklist is ALSO paused, surface it as context in the
                    // message so the user knows but is not blocked from the open task.
                    const t = summary.nextOpenTask;
                    let dueLabel = '';
                    if (t?.due_at) {
                        const due = moment(t.due_at);
                        if (due.isValid()) {
                            const isOverdue = due.startOf('day').isBefore(moment().startOf('day'));
                            dueLabel = isOverdue
                                ? ` · Overdue (due ${due.format('D MMM')})`
                                : ` · Due ${due.format('D MMM')}`;
                        }
                    }
                    const taskTitle = `${t?.title || 'Next task'}${dueLabel}`;
                    // When a checklist is paused but an open task still exists, prepend
                    // paused context so the user can see both signals at a glance.
                    const pausedUntilDate = summary.pausedUntil ? parseApiDate(summary.pausedUntil) : null;
                    const pausedUntilSuffix = pausedUntilDate?.isValid() ? ` until ${pausedUntilDate.format('D MMM')}` : '';
                    const message = summary.paused > 0
                        ? `Checklist paused${pausedUntilSuffix} · ${taskTitle}`
                        : taskTitle;
                    return {
                        type: 'OPEN_TASK',
                        icon: 'fluent:tasks-app-28-regular',
                        color: '#078DEE',
                        bgColor: 'rgba(7, 141, 238, 0.08)',
                        message,
                        cta: 'Open task',
                        action: 'open_next_task',
                        treatment,
                        ui,
                    };
                }
                // ── open === 0: discriminate PAUSED vs COMPLETE_FOLLOWUP vs DONE ──
                //
                // Per-treatment signals (from TaskChecklistCard summaryMap via computeItemSummary):
                //   hasPausedWork:        any WORK item (NOT a touchpoint) is PAUSED → on hold
                //   hasPausedTouchpoints: any TOUCHPOINT item is PAUSED → follow-up scheduled
                //   _workCount:           total WORK items across all tasks
                //   _workDoneCount:       WORK items that are YES or SKIPPED
                //
                // TOUCHPOINT types (do not block completion):
                //   LEAD_NEXT_ACTION, CONFIRMATION, LOG_PHONE_CALL, EMAIL_SENT,
                //   WHATSAPP_SENT, SMS_SENT, PHONE_CALLED, SCHEDULE_REMINDER, OPEN_FOLLOW_UP
                // WORK types (block if PAUSED / PENDING) = everything else (incl. unknowns).
                //
                // allWorkDone: no WORK items are blocked, and done count matches total.
                // NOTE: _workCount may be 0 when TaskChecklistCard's group-filter removes
                // prior-stage task groups (e.g. CONSULTATION_ATTENDED prior-stage group is
                // excluded before the summaryMap useEffect runs). In that case
                // _workCount=0, _workDoneCount=0 → 0===0 → true, which is correct:
                // the filtered-out work items were completed in a prior stage, so
                // "all visible work done" is the right semantic. hasPausedWork still
                // catches genuine on-hold leads (a PAUSED work item would appear in the
                // remaining (current-stage) group and flip hasPausedWork=true).
                const allWorkDone = !summary.hasPausedWork
                    && (summary._workDoneCount || 0) === (summary._workCount || 0);

                // Branch 1: any WORK item is PAUSED → lead genuinely on hold.
                if (summary.hasPausedWork) {
                    return {
                        type: 'PAUSED',
                        icon: 'mdi:pause-circle-outline',
                        color: '#FFAB00',
                        bgColor: 'rgba(255, 171, 0, 0.08)',
                        message: (() => {
                            const d = summary.pausedUntil ? parseApiDate(summary.pausedUntil) : null;
                            return d?.isValid() ? `Checklist paused until ${d.format('D MMM')}` : 'Checklist paused';
                        })(),
                        cta: noTaskCtaLabel,
                        action: 'no_task_cta',
                        treatment,
                        status,
                        ui,
                    };
                }
                // Branch 2: all work done AND touchpoints paused with a date →
                // "Checklist complete · follow-up paused until D MMM".
                //
                // Real data (167175 Invisalign, tx 139045):
                //   12 WORK items: YES (YES_NO_TOGGLE consent, PAYMENT_METHOD, SIMPLE_DATE
                //   exam/OPG/fit, STAFF_PICKER aligners, SEND_CONSENT_FORM, SEND_PAYMENT_LINK,
                //   SEND_TREATMENT_PLAN, UPLOAD_DOCUMENT, LOG_PHONE_CALL)
                //   6 TOUCHPOINT items PAUSED: 4 LEAD_NEXT_ACTION + 2 CONFIRMATION
                //   ("Open Follow Up — set custom date", "Same Day ClinCheck Call")
                //   → allWorkDone=true, hasPausedTouchpoints=true → COMPLETE_FOLLOWUP ✅
                if (allWorkDone && summary.hasPausedTouchpoints && summary.pausedUntil && moment(summary.pausedUntil).isValid()) {
                    return {
                        type: 'COMPLETE_FOLLOWUP',
                        icon: 'material-symbols:check-circle-outline',
                        color: '#22C55E',
                        bgColor: 'rgba(34, 197, 94, 0.08)',
                        message: `Checklist complete · follow-up paused until ${moment(summary.pausedUntil).format('D MMM')}`,
                        cta: noTaskCtaLabel,
                        action: 'no_task_cta',
                        treatment,
                        status,
                        ui,
                    };
                }
                // Branch 3: paused (touchpoints only, no date — or no work items at all).
                // Fallback for any remaining paused state: open-ended follow-up or edge case.
                if (summary.paused > 0) {
                    return {
                        type: 'PAUSED',
                        icon: 'mdi:pause-circle-outline',
                        color: '#FFAB00',
                        bgColor: 'rgba(255, 171, 0, 0.08)',
                        message: 'Checklist paused',
                        cta: noTaskCtaLabel,
                        action: 'no_task_cta',
                        treatment,
                        status,
                        ui,
                    };
                }
                // All tasks complete → compact done card
                return { type: 'DONE', _done: true, _doneLabel: 'All tasks complete', treatment };
            }

            // 4. No tasks → NO_OPEN_TASKS card.
            // Uses getLeadStatusUi for colors, icon, and status-specific no-task message.
            // CTA calls the same status-aware btnHandler via no_task_cta → resolver.
            return {
                type: 'NO_OPEN_TASKS',
                icon: ui.icon,
                color: ui.color,
                bgColor: ui.bgColor,
                message: ui.noTaskMessage,
                cta: noTaskCtaLabel,
                action: 'no_task_cta',
                treatment,
                status,
                ui,
            };
        }).filter(Boolean);

        // Hide section entirely when every suggestion is a done card
        if (suggestions.length > 0 && suggestions.every((s) => s._done)) return [];
        return suggestions;
    };

    // ─── Next Step / Treatment-card CTA dedupe (one action per treatment) ───
    // Computed once per render and shared by both the Next-step cards section
    // and renderTreatmentCard. The Next-step box is the richer surface (icon,
    // message, prominent CTA) and always renders for every suggestion type —
    // renderTreatmentCard hides ITS OWN button instead, per-treatment, whenever
    // the Next-step box already offers the identical btnHandler(treatment)
    // action: NO_OPEN_TASKS / PAUSED / COMPLETE_FOLLOWUP (action:'no_task_cta')
    // and OPEN_TASK (action:'open_next_task') all end up calling btnHandler for
    // that treatment (see handleNextStepAction), so showing both was two
    // identical CTAs. FORM_SUBMITTED_RECENT (action:'forms') opens the Forms
    // tab — a genuinely different action — so the treatment card button stays
    // visible alongside it.
    const nextStepSuggestions = (!hasTasksV2 || taskSummaryReady) ? getNextStepSuggestions() : [];
    const suggestionByTreatmentId = new Map(
        nextStepSuggestions
            .filter((s) => s?.treatment?.id != null)
            .map((s) => [String(s.treatment.id), s])
    );

    // Mirrors TaskBodyView.closeTreatmentHub / handleTreatmentHubYes so the
    // Overview opens the exact same treatment-in-progress hub the task sidebar's
    // Follow-up opens, and completes via the same CompleteTreatment thunk.
    const closeTreatmentHub = (wasGenuineCompletion = false) => {
        setOpenTreatmentHub(false);
        setHubRow(null);
        dispatch(setLoader(false));
        setTimeout(() => { document.querySelector('body')?.classList.remove('overflow-hidden'); }, 200);
        if (wasGenuineCompletion) {
            getLeadData();
            dispatch(followUpSlice(leadDetail?.id, practiceId, 'LeadDetail'));
        }
    };

    const handleTreatmentHubYes = () => {
        dispatch(setLoader(true));
        dispatch(CompleteTreatment(
            { treatment: hubRow?.treatment_name || '', custom_price: hubRow?.price },
            hubRow?.lead_id,
            hubRow?.treatment_id,
            practiceId,
            () => { closeTreatmentHub(true); },
        ));
    };

    const handleNextStepAction = (suggestion) => {
        if (!suggestion) return;
        // Scope the opened flow (popup / pause) to the treatment the user clicked —
        // otherwise AttendedAppointment falls back to lead_treatments[0] for name/price
        // and the pause cascade goes lead-wide (paused-both bug) on multi-treatment leads.
        if (suggestion.treatment) {
            handleSetTreatmentDataGlobal({ leadDetail, treatment: suggestion.treatment, setCurrentTreatmentData });
        }
        if (suggestion.action === 'open_next_task') {
            // Open the SAME popup the task sidebar's Follow-up opens, routed by
            // the lead's treatment status. TREATMENT_STARTED → the treatment hub
            // (CompletedTreatmentHub); every other status falls through to the
            // existing status popups via btnHandler.
            const {treatment} = suggestion;
            const status = treatment?.status || getTreatmentDetails('status', treatment, leadDetail);
            if (status === 'TREATMENT_STARTED') {
                const lt = treatment;
                document.querySelector('body')?.classList.add('overflow-hidden');
                setHubRow({
                    lead_id: leadDetail?.id,
                    id: leadDetail?.id,
                    first_name: leadDetail?.first_name || '',
                    last_name: leadDetail?.last_name || '',
                    status: 'TREATMENT_STARTED',
                    treatment_id: lt?.id,
                    treatment_name: lt?.treatment || lt?.treatment_name || '',
                    price: lt?.price || lt?.custom_price || '',
                    treatmentData: lt ? [lt] : [],
                });
                setOpenTreatmentHub(true);
            } else {
                btnHandler('', '', treatment);
            }
            return;
        }
        if (suggestion.action === 'no_task_cta') {
            // NO_OPEN_TASKS card CTA — route to the same status-aware popup that
            // btnHandler would open for this treatment. The treatment object carries
            // the correct status so the resolver routes to the right flow without
            // ever falling back to lead_treatments[0].
            btnHandler('', '', suggestion.treatment);
            return;
        }
        if (suggestion.action === 'communicate') {
            onChangeTab('', 'All communications');
        } else if (suggestion.action === 'forms') {
            // Route to the Forms tab — the user can drill into the recent submission there.
            onChangeTab('', 'Forms');
        }
    };

    const handleToggleBookingMode = (useDentally) => {
        setUseDentallyFlow(useDentally);
        if (!useDentally) {
            setDentallySlot(null);
            setSelectedDentallyTreatment(null);
            setDentallyAssignees([]);
        }
    };

    // ─── Timeline Helpers ───
    const getActivityCategory = (activity) => {
        const verb = activity?.verb?.toLowerCase() || '';
        if (verb.includes('note') || verb.includes('comment')) return 'Notes';
        if (verb.includes('email') || verb.includes('whatsapp') || verb.includes('sms') || verb.includes('call')) return 'Communication';
        return 'System';
    };

    const filteredActivities = activityList?.filter((activity) => {
        if (timelineFilter === 'All') return true;
        return getActivityCategory(activity) === timelineFilter;
    });

    // ─── Render Treatment Card ───
    const renderTreatmentCard = (ele, index, length) => {
        const appointment = nearestDataV2(ele?.appointments) || nearestPastDataV2(ele?.appointments);
        const laneColor = getLeadStatusUi(ele.status)?.color || '#919EAB';
        // Appointment shown on the card: this treatment's next upcoming, else its most
        // recent past (e.g. the last Attended date). Sourced from the lead's appointment
        // list filtered by treatment (reliable) rather than the treatment object.
        // Filter directly — nearestData/nearestPastData are scoped to the ConsultantBooked
        // table (BOOKED statuses only) and exclude ATTENDED, so compute here.
        const APPT_FMT = ['DD-MM-YYYY HH:mm:ss.SSSSSSZ', 'DD-MM-YYYY HH:mm:ss', moment.ISO_8601];
        const laneApptM = (d) => moment(d, APPT_FMT);
        const laneAppts = (followLead?.lead_appointment || []).filter((a) => String(a?.lead_treatment) === String(ele.id));
        const upcomingLaneAppt = laneAppts
            .filter((a) => ['BOOKED', 'CONSULTATION_BOOKED'].includes(a?.status) && laneApptM(a.datetime).isAfter(moment()))
            .sort((a, b) => laneApptM(a.datetime).diff(laneApptM(b.datetime)))[0];
        const lastAttendedAppt = laneAppts
            .filter((a) => /ATTENDED/i.test(a?.status || ''))
            .sort((a, b) => laneApptM(b.datetime).diff(laneApptM(a.datetime)))[0];
        const shownAppt = upcomingLaneAppt || lastAttendedAppt;
        const shownApptLabel = shownAppt
            ? `${upcomingLaneAppt ? 'Next appointment' : 'Last attended'} · ${laneApptM(shownAppt.datetime).format('DD MMM YYYY')}`
            : 'No appointment';

        // Per-treatment (not global) dedupe — see suggestionByTreatmentId above.
        // The Next-step box above is the richer surface (icon, message, prominent
        // CTA) and stays for every suggestion type. This card's own button is
        // hidden only when the Next-step box already offers the SAME btnHandler
        // action for this treatment — action:'open_next_task' (a specific open
        // task) or action:'no_task_cta' (NO_OPEN_TASKS/PAUSED/COMPLETE_FOLLOWUP,
        // all of which call btnHandler(treatment) just like this button does).
        // Shown when: there's no suggestion yet for this treatment (e.g. task
        // summary not ready, or every suggestion is a done-card and the section
        // is hidden entirely), the suggestion is a compact `_done` card, or the
        // action is 'forms' (FORM_SUBMITTED_RECENT — a genuinely different
        // action, review a form submission, not this button's action).
        const treatmentSuggestion = suggestionByTreatmentId.get(String(ele.id));
        const suppressTreatmentCardButton = treatmentSuggestion?.action === 'open_next_task'
            || treatmentSuggestion?.action === 'no_task_cta';

        return (
            <Box key={index} sx={{
                ...treatmentProgressCard,
                // Plain sub-card (no left accent), sized for the side-by-side / carousel layout.
                borderRadius: '12px',
                border: '1px solid rgba(145, 158, 171, 0.16)',
                boxShadow: 'none',
                bgcolor: common.white,
                flex: length === 1 ? '1 1 100%' : '1 1 calc(33.33% - 12px)',
                minWidth: length === 1 ? '100%' : 'calc(33.33% - 12px)',
                maxWidth: length === 1 ? '100%' : undefined,
                '@media (max-width: 1559px)': {
                    flex: length === 1 ? '1 1 100%' : '1 1 calc(50% - 12px)',
                    minWidth: length === 1 ? '100%' : 'calc(50% - 12px)',
                },
            }}>
                {/* Header */}
                <Box sx={treatmentCardHeader}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0, flex: 1, flexWrap: 'wrap' }}>
                        <Typography sx={treatmentNameStyle}>{ele?.treatment}</Typography>
                        <Typography sx={treatmentPriceStyle}>{`\u00A3${ele?.price}`}</Typography>
                        {/* Status chip \u2014 uses getLeadStatusChipSx (JOURNEY_STAGES aligned colors
                            from leadStatusUi) so colors/icons match the Next Step card eyebrow. */}
                        <Button sx={getLeadStatusChipSx(ele.status)}>
                            <Iconify
                                icon={getLeadStatusUi(ele.status).icon}
                                width={16}
                                height={16}
                            />
                            {getStatus(ele)}
                        </Button>
                    </Box>
                    <Box sx={dotsIconBoxStyle} onClick={() => handleTogglePopper(ele.id, ele)} ref={anchorTreatmentRef} id={`button-${ele.id}`}>
                        <Iconify icon={'mdi:dots-horizontal'} sx={{ color: common.grey }} width={24} height={24} />
                    </Box>
                </Box>

                {/* Next appointment for this treatment */}
                <Stack direction="row" alignItems="center" spacing={0.75} sx={{ mt: 1.5, mb: 0.5 }}>
                    <Iconify icon="solar:calendar-mark-bold-duotone" width={16} sx={{ color: shownAppt ? laneColor : common.grey }} />
                    <Typography sx={{ fontSize: 13, color: shownAppt ? 'text.primary' : 'text.disabled' }}>
                        {shownApptLabel}
                    </Typography>
                </Stack>

                {/* Mini Phase Stepper removed \u2014 the lead-status colour is now
                    conveyed by the card's left accent border (statusColor). */}

                {/* Status pill moved into the header beside the price. */}

                {/* Action button — hidden only for THIS treatment when the
                    Next-step box above already offers the identical btnHandler
                    action (open_next_task / no_task_cta). Scoped per-treatment
                    (not the old global `nextDueTask` flag) so a task on one
                    treatment no longer hides every other treatment's button on
                    multi-treatment leads. */}
                {!suppressTreatmentCardButton && (
                    <Button
                        variant='outlined'
                        disabled={ele.status === 'CLOSED' || (ele.status === 'CONSULTATION_BOOKED' && appointment?.[0]?.status === 'CANCELLED')}
                        onClick={(e) => btnHandler(e, '', ele)}
                        sx={flwBtnStyle(ele.status === 'CLOSED' || (ele.status === 'CONSULTATION_BOOKED' && appointment?.[0]?.status === 'CANCELLED'))}
                    >
                        {getBtnName(ele)}
                    </Button>
                )}

                {/* Treatment edit Popper */}
                <Popper
                    sx={{ zIndex: 1, marginLeft: '10px !important' }}
                    open={isPopperOpen(ele.id)}
                    anchorEl={anchorTreatmentRef.current}
                    role={undefined}
                    placement='bottom-start'
                    transition
                    disablePortal
                >
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            style={{
                                transformOrigin: placement === 'bottom-start' ? 'left top' : 'left bottom',
                                width: '180px',
                            }}
                        >
                            <Paper>
                                <ClickAwayListener onClickAway={() => setTreatmentOpen((prevOpen) => !prevOpen)}>
                                    <MenuList
                                        autoFocusItem
                                        id='composition-menu'
                                        aria-labelledby='composition-button'
                                        sx={paperMenuItem}
                                    >
                                        <MenuItem onClick={() => handleClickEditTreatment(ele)} sx={editDetailMenuItem}>
                                            <Iconify icon={'solar:pen-bold'} sx={{ mr: 1 }} />
                                            Edit Treatment
                                        </MenuItem>
                                    </MenuList>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            </Box>
        );
    };

    useEffect(() => {
        if (openContactFromCall) {
            btnHandler('', '', activeTreatment || finalTreatmentArray?.[0], true);
        }
    }, [openContactFromCall])

    if (!leadDetail) return null;

    // Lead-status colour for the enquiry card's action-card styling (left
    // accent + mood gradient), from the primary treatment's status.
    const primaryStatus = finalTreatmentArray?.[0]?.status;
    const primaryStatusColor = (primaryStatus === 'FAILED_TO_ATTEND_CONSULTATION' || primaryStatus === 'FAILED_TO_ATTEND')
        ? '#FF5630'
        : (JOURNEY_STAGES[getStageIndex(primaryStatus)]?.color || '#919EAB');

    const handleClickAwayLister = (e, popup1Ref) => {
        if (popup1Ref && popup1Ref.current) {
            if (!popup1Ref.current?.contains(e.target)) {
                onCloseEditTreatment();
                dispatch(followUpSlice(leadDetail.id, practiceId, 'LeadDetail'));
                return;
            }
            return;
        }
        onCloseEditTreatment();
        dispatch(followUpSlice(leadDetail.id, practiceId, 'LeadDetail'));
    };

    const handleReloadAPI = (status) => {
        document.body.classList.remove('points-event');
        if (status?.toLowerCase?.() === 'finish') {
            handleClickAwayLister();
            dispatch(clearLead());
            dispatch(setCurrentTreatmentDataGlobal(null));
            if (leadDetail && leadDetail.id) {
                dispatch(getLeadReminderData(practiceId, 'LeadDetail', 10, 0, '', leadDetail.id, ''));
                dispatch(getLeadReminderData(practiceId, 'LeadDetail', 1, 0, '', leadDetail?.id, '', '', 'Graterthan'));
                dispatch(followUpSlice(leadDetail.id, practiceId, 'LeadDetail'));
                dispatch(getActivities(practiceId, leadDetail.id, 10, 0));
            }
        }
    };

    const onClickAwayEvent = () => {
        const selectMenu = document.querySelector('.MuiModal-root');
        if (selectMenu) {
            return;
        }
        onCloseAssignTask();
        setAnchorElAssign(null);
        dispatch(clearPracticeUserData());
    };

    const appointmentClickAwayEvent = () => {
        const selectMenu = document.querySelector('.MuiModal-root');
        if (selectMenu) {
            return;
        }
        onCloseAppointmentAssignTaskPopup();
        setAnchorElAssign(null);
        dispatch(clearPracticeUserData());
    };

    const handleCloseEmailCompose = () => {
        setTemplateOpen(false);
        setLeadData({});
        document.body.style.overflowY = 'auto';
    };

    const handleCloseAppointmentAssignee = () => {
        onCloseAppointmentAssignTaskPopup();
        setAnchorElAssign(null);
    };

    return (
        <Stack>
            <SimilarLeadWarningPopup />
            {/* Enquiry Summary Card — styled like the attended popup's action
                cards: 16px radius, soft layered shadow, a status-coloured left
                accent, and a subtle radial mood gradient in that colour. */}
            <Card sx={{
                ...overViewCard,
                mt: 3,
                mb: 4,
                borderRadius: '16px',
                border: 'none',
                borderLeft: `5px solid ${primaryStatusColor}`,
                boxShadow: '0 1px 3px rgba(0,0,0,0.04), 0 8px 24px rgba(0,0,0,0.06)',
                background: `radial-gradient(at top left, ${primaryStatusColor}14 0%, transparent 55%), #ffffff`,
            }}>
                {/* The Resource referral indicator now lives only beside the
                    "contact attempts" chip in the header pill row — the leading
                    icon that used to sit next to the name here was removed to
                    avoid duplicating it. */}
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start' }}>
                    <Box sx={{ minWidth: 0, flex: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                            <Typography sx={{ fontWeight: 700, fontSize: '14px', lineHeight: '20px', mb: 0.25 }}>
                                <span style={{ textTransform: 'capitalize' }}>{leadDetail?.first_name || ''}</span> enquired about {activeTreatment?.treatment || ''}
                            </Typography>
                            {(() => {
                                const score = leadDetail?.engagement_score ?? null;
                                if (score === null) return null;
                                const engColor = score >= 76 ? '#10b981' : score >= 51 ? '#3b82f6' : score >= 26 ? '#f59e0b' : '#ef4444';
                                return (
                                    <Tooltip title={`Engagement score: ${score}/100`} placement='top' TransitionComponent={Zoom} TransitionProps={{ timeout: 300 }}>
                                        <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, px: 0.75, py: 0.25, borderRadius: '12px', bgcolor: `${engColor}18`, border: `1px solid ${engColor}40`, mb: 0.25 }}>
                                            <Box sx={{ width: 7, height: 7, borderRadius: '50%', bgcolor: engColor, flexShrink: 0 }} />
                                            <Typography variant='caption' sx={{ fontWeight: 700, color: engColor, lineHeight: 1.4 }}>{score}</Typography>
                                        </Box>
                                    </Tooltip>
                                );
                            })()}
                            {(() => {
                                // Click-to-WhatsApp ad attribution — when the lead arrived
                                // via a Meta CTWA ad, the backend captures the referral
                                // block on `LeadSource.metadata.wa_referral`. Show a small
                                // pill so the practice can see at a glance which ad earned
                                // the conversation. Hidden when no referral exists.
                                const waRef = leadDetail?.lead_source?.metadata?.wa_referral;
                                if (!waRef || typeof waRef !== 'object') return null;
                                const headline = waRef.headline || waRef.body || 'WhatsApp ad';
                                const sourceUrl = waRef.source_url || '';
                                const adColor = '#1877f2'; // Meta blue
                                const tooltip = sourceUrl
                                    ? `Came from ad: ${headline}\n${sourceUrl}`
                                    : `Came from ad: ${headline}`;
                                return (
                                    <Tooltip title={tooltip} placement='top' TransitionComponent={Zoom} TransitionProps={{ timeout: 300 }}>
                                        <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, px: 0.75, py: 0.25, borderRadius: '12px', bgcolor: `${adColor}18`, border: `1px solid ${adColor}40`, mb: 0.25, maxWidth: 220 }}>
                                            <Iconify icon='ic:baseline-campaign' sx={{ color: adColor, flexShrink: 0 }} width={14} height={14} />
                                            <Typography variant='caption' sx={{ fontWeight: 700, color: adColor, lineHeight: 1.4, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                {headline}
                                            </Typography>
                                        </Box>
                                    </Tooltip>
                                );
                            })()}
                        </Box>
                        <Typography variant='body2' sx={{ color: 'grey.500', fontSize: '13px', lineHeight: '18px' }}>
                            {leadDetail?.lead_contact?.note ? <span style={{ display: 'block', fontWeight: 400, mb: '2px' }}>{leadDetail?.lead_contact?.note}</span> : null}
                            <span style={{ fontSize: '12px' }}>{leadDetail?.created_at_human || ''}</span>
                        </Typography>
                    </Box>
                </Box>
                {((metaData && metaData.length !== 0 && metaData.some(el => el.key && el.key.endsWith('?'))) || (leadSourceMetaData && typeof leadSourceMetaData === 'object' && Object.entries(leadSourceMetaData)?.length !== 0 && Object.entries(leadSourceMetaData).some(([key]) => key && key.endsWith('?')))) && <List sx={{ maxWidth: '100%', m: '8px 0 -24px' }}>
                    {metaData && metaData?.map((el, index) => {
                        const { key, value } = el;
                        if (key.endsWith('?')) {
                            return (
                                <ListItem alignItems='flex-start' key={index} sx={{ p: '8px 0' }}>
                                    <ListItemAvatar sx={{ mt: '1px' }}>
                                        <Iconify icon={'charm:info'} color={common.mintBlue} width={24} height={24} />
                                    </ListItemAvatar>
                                    <ListItemText primary={key} secondary={`— ${value}`} sx={textStyle} />
                                </ListItem>
                            );
                        }
                        return null;
                    })}
                    {/* Guard: leadSourceMetaData can be null/undefined during load (REACT-CZ, 4 users) */}
                    {leadSourceMetaData && typeof leadSourceMetaData === 'object' && Object.entries(leadSourceMetaData).map(([key, value], index) => {
                        if (key.endsWith('?')) {
                            return (
                                <ListItem alignItems='flex-start' key={index} sx={{ p: '8px 0' }}>
                                    <ListItemAvatar sx={{ mt: '1px' }}>
                                        <Iconify icon={'charm:info'} color={common.blue} width={24} height={24} />
                                    </ListItemAvatar>
                                    <ListItemText primary={key} secondary={`— ${value}`} sx={textStyle} />
                                </ListItem>
                            );
                        }
                        return null;
                    })}
                </List>}

                {/* Identity/attribution audit — both render null when the lead has no data. */}
                <MergeHistoryCard leadDetail={leadDetail} practiceId={practiceId} />
                <JourneyHistory leadDetail={leadDetail} />

                {/* Next Step Suggestions — one card per treatment, side-by-side row.
                    This is the richer box (icon, message, prominent CTA) and is the
                    single source of truth for every suggestion type, including
                    NO_OPEN_TASKS/PAUSED/COMPLETE_FOLLOWUP — renderTreatmentCard hides
                    its own duplicate button for those (see suggestionByTreatmentId
                    above) instead of this section hiding anything. */}
                {(() => {
                    const suggestions = nextStepSuggestions;
                    if (!suggestions.length) return null;
                    const multiTreatment = (finalTreatmentArray?.length || 0) > 1;
                    return (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, mt: 2 }}>
                            {suggestions.map((suggestion, idx) => {
                                const tName = suggestion.treatment?.treatment || suggestion.treatment?.treatment_name || '';
                                // Compact done-state card for CLOSED treatments
                                if (suggestion._done) {
                                    return (
                                        <Box key={idx} sx={{ flex: '1 1 calc(50% - 12px)', minWidth: 240, p: 1.5, borderRadius: '10px', bgcolor: 'action.hover', border: '1px solid', borderColor: 'divider', display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Iconify icon='eva:checkmark-circle-2-fill' width={18} height={18} sx={{ color: 'text.disabled', flexShrink: 0 }} />
                                            <Typography sx={{ fontSize: '13px', color: 'text.disabled' }}>
                                                {tName || suggestion._doneLabel}
                                                {tName ? ` · ${suggestion._doneLabel}` : ''}
                                            </Typography>
                                        </Box>
                                    );
                                }
                                return (
                                    <Box key={idx} sx={{
                                        flex: '1 1 calc(50% - 12px)',
                                        minWidth: 240,
                                        p: 2.5,
                                        borderRadius: '12px',
                                        bgcolor: '#fff',
                                        border: `1px solid ${suggestion.color}29`,
                                        background: `radial-gradient(at top left, ${suggestion.color}14 0%, transparent 55%), #fff`,
                                        ...dbgSx('#078DEE'),
                                    }}>
                                        <DbgTag color="#078DEE" label={`NextStep tx:${suggestion?.treatment?.id} ${suggestion?.treatment?.status} cta:${suggestion?.cta} act:${suggestion?.action}`} />
                                        {/* Treatment name label — shown only when multiple treatments */}
                                        {multiTreatment && tName && (
                                            <Typography sx={{ fontSize: '11px', fontWeight: 600, color: 'text.disabled', letterSpacing: '0.03em', textTransform: 'uppercase', mb: 1 }}>
                                                {tName}
                                            </Typography>
                                        )}
                                        {/* Eyebrow — colour dot + label */}
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 1.5 }}>
                                            <Box sx={{ width: 7, height: 7, borderRadius: '50%', bgcolor: suggestion.color, flexShrink: 0 }} />
                                            <Typography sx={{ fontSize: '11px', fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', color: suggestion.color }}>
                                                {suggestion.type === 'OPEN_TASK' ? 'Next task' : suggestion.type === 'NO_OPEN_TASKS' ? 'No open tasks' : suggestion.type === 'PAUSED' ? 'Checklist paused' : suggestion.type === 'COMPLETE_FOLLOWUP' ? 'Checklist complete' : 'Next step'}
                                            </Typography>
                                        </Box>
                                        {/* Icon + title */}
                                        <Stack direction='row' alignItems='flex-start' spacing={1.5} sx={{ mb: 2 }}>
                                            <Box sx={{ width: 48, height: 48, borderRadius: '12px', bgcolor: `${suggestion.color}1A`, border: `1.5px solid ${suggestion.color}33`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                                <Iconify icon={suggestion.icon} width={24} height={24} sx={{ color: suggestion.color }} />
                                            </Box>
                                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                                <Typography sx={{ fontSize: '16px', fontWeight: 700, color: '#1d1d1f', lineHeight: 1.3, letterSpacing: '-0.01em', wordBreak: 'break-word' }}>
                                                    {suggestion.message}
                                                </Typography>
                                            </Box>
                                        </Stack>
                                        {/* Prominent CTA */}
                                        <Button
                                            variant='contained'
                                            fullWidth
                                            onClick={() => handleNextStepAction(suggestion)}
                                            sx={{ bgcolor: suggestion.color, color: '#fff', fontWeight: 700, fontSize: '14px', py: 1.25, borderRadius: '10px', textTransform: 'none', boxShadow: 'none', '&:hover': { bgcolor: suggestion.color, opacity: 0.92, boxShadow: 'none' } }}
                                        >
                                            {suggestion.cta}
                                        </Button>
                                    </Box>
                                );
                            })}
                        </Box>
                    );
                })()}


                {/* Recent Consent Submission Banner removed — now handled inside the
                    centralised NEXT_STEP_SUGGESTIONS engine via FORM_SUBMITTED_RECENT,
                    so we don't show two stacked banners for the same event. */}

                {/* Dentally Deferred Booking Pending — payment awaiting */}
                {dentallyVisible && (
                    <DentallyPendingBookingBanner
                        practiceId={practiceId}
                        leadDetail={leadDetail}
                        onComplete={() => dispatch(followUpSlice(leadDetail?.id, practiceId, 'LeadDetail'))}
                    />
                )}

                {/* Treatment Progress Cards — inside enquiry card */}
                <Box sx={{ width: '100%', mt: 2 }}>
                    <Box sx={overViewDynamicOuterBox(finalTreatmentArray)}>
                        {finalTreatmentArray.length > 2 ?
                            <Box sx={finalTreatmentBoxStyle(finalTreatmentArray)}>
                                <Swiper
                                    modules={[Navigation]}
                                    spaceBetween={16}
                                    slidesPerView={2}
                                    navigation={{
                                        nextEl: '.swiper-button-next',
                                        prevEl: '.swiper-button-prev',
                                    }}
                                    pagination={{ clickable: true }}
                                    scrollbar={{ draggable: true }}
                                    breakpoints={{
                                        1560: { slidesPerView: 3 },
                                        768: { slidesPerView: 2 },
                                        0: { slidesPerView: 1 },
                                    }}
                                >
                                    {finalTreatmentArray?.map((ele, index) => <SwiperSlide key={index}>
                                        {renderTreatmentCard(ele, index, finalTreatmentArray?.length)}
                                    </SwiperSlide>)}
                                </Swiper>
                                <div className='swiper-button-next' />
                                <div className='swiper-button-prev' />
                            </Box>
                            :
                            finalTreatmentArray?.map((ele, index) => renderTreatmentCard(ele, index, finalTreatmentArray?.length))
                        }
                        {leadDetail && leadDetail.lead_treatments && leadDetail.lead_treatments?.length === 0 && <Box sx={{ display: 'flex' }}>
                            <Button sx={{ display: 'flex', justifyContent: 'flex-start' }} variant='contained' onClick={(event) => handleAddTreatment(event)}>
                                <Iconify sx={{ mr: '8px' }} icon={'eva:plus-fill'} width={20} height={20} /> Add treatment
                            </Button>
                        </Box>}
                    </Box>
                </Box>
            </Card>
            {/* Headless: no visible card on the Overview (it's on the Tasks
                tab). Still feeds the "Next step" card via onNextTaskResolved. */}
            {hasTasksV2 && leadDetail?.id && (
                <TaskChecklistCard
                    practiceId={practiceId}
                    leadId={leadDetail.id}
                    leadData={leadDetail}
                    onNextTaskResolved={setNextDueTask}
                    onTreatmentTaskSummary={setTreatmentTaskSummary}
                    onFirstFetchDone={() => setTaskSummaryReady(true)}
                    hideCard
                />
            )}
            {/* #185 — Recent attachments mini-list. Self-hides when the lead has no media. */}
            {leadDetail?.id && practiceId && (
                <RecentAttachments
                    practiceId={practiceId}
                    leadId={leadDetail.id}
                    onViewAll={() => onChangeTab('', 'All communications')}
                />
            )}
            <Box sx={overviewMainBoxStyle}>
                {(upComingData || leadDetail?.lead_treatments?.length > 0) && <Box sx={overviewLeftLayoutBoxStyle}>
                    {upComingData && <Card sx={{ p: 2, mb: 3, borderRadius: 2, border: '1px solid', borderColor: 'divider', boxShadow: 'none' }} >
                        <Box
                            key={upComingData?.id}
                            sx={{ display: 'flex', width: '100%' }}
                        >
                            <Box sx={{ minWidth: '20px', mt: '0' }}>
                                <Tooltip title={markComplete ? 'Mark as incomplete' : 'Mark as complete'} placement='bottom' TransitionComponent={Zoom} TransitionProps={{ timeout: 300 }}>
                                    <Radio
                                        checked={markComplete}
                                        onClick={() => markCompleteBtn(upComingData?.id)}
                                        name='radioButtons'
                                        sx={{ p: 1, '.MuiSvgIcon-root': { width: '24px', height: '24px' } }}
                                    />
                                </Tooltip>
                            </Box>
                            <Paper
                                onClick={() => sidebarHandler(upComingData)}
                                sx={{
                                    ...paperStyle,
                                    pointerEvents: upComingData?.lead?.is_archive_pending || upComingData?.lead?.archived_at ? 'none' : null
                                }}
                            >
                                <Box sx={messageBox}>
                                    <Box>
                                        <Box sx={{ p: '0 24px 0 0' }}>
                                            {upComingData?.lead_treatment?.treatment && (
                                                <Typography sx={{ fontSize: '11px', color: 'text.disabled', fontWeight: 500, mb: 0.25, letterSpacing: '0.02em' }}>
                                                    {upComingData.lead_treatment.treatment}
                                                </Typography>
                                            )}
                                            {upComingData.title !== '' ? <Box sx={{ fontSize: '16px', lineHeight: '24px' }} ><b>{capitalizeFirstLetter(upComingData?.title)}</b></Box> : getMessage(upComingData?.lead_treatment?.status, upComingData?.lead?.first_name, upComingData?.lead?.last_name, upComingData?.lead_treatment?.treatment, upComingData?.group, upComingData?.method)}
                                        </Box>
                                        <Box
                                            sx={{ ...avatarBox, mb: 0 }}
                                        >
                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', mt: '6px' }}>
                                                <Box sx={{ display: 'flex' }} >
                                                    <Box
                                                        sx={{
                                                            color: upComingData?.datetime_human.includes('now' || 'NOW') ? common.lightGreen : common.red,
                                                            ...timeLabel
                                                        }}
                                                    >
                                                        <Iconify icon={'charm:clock-alarm'} width={14} height={14} sx={{ mr: '4px' }} />
                                                        {upComingData?.datetime_human && upComingData?.datetime_human || ''}
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>
                                    <Box>
                                        {assigneeData?.length > 0 ?
                                            <Box
                                                sx={avatarInnerBox}
                                                onClick={(e) => e.stopPropagation()}
                                            >
                                                <DemoBlur component='div'>
                                                <Tooltip title={piiTitle(getAssignees(upComingData))} placement='bottom' TransitionComponent={Zoom} TransitionProps={{ timeout: 300 }}>
                                                    <Box sx={{ display: 'flex' }}>
                                                        {assigneeData?.slice(0, 2)?.map((assignee, index) => (
                                                            <AssignUserAvatar
                                                                key={index}
                                                                sx={assignUserAvatarStyle}
                                                                src={assignee.user?.avatar || ''}
                                                                name={`${assignee.user?.first_name || ''} ${assignee.user?.last_name || ''}`}
                                                                role={assignee.role}
                                                                onClick={(e) => OpenAssignTask(upComingData, e)}
                                                            />
                                                        ))}
                                                        {assigneeData?.length > 2 && (
                                                            <Box sx={assignLengthStyle} onClick={(e) => OpenAssignTask(upComingData, e)}>
                                                                + {assigneeData?.length - 2}
                                                            </Box>
                                                        )}
                                                    </Box>
                                                </Tooltip>
                                                </DemoBlur>
                                            </Box> :
                                            <Box
                                                sx={unassignedBoxStyle}
                                                onClick={(e) => e.stopPropagation()}
                                            >
                                                <Box onClick={(e) => OpenAssignTask(upComingData, e)} sx={plusIconBox}>
                                                    <Iconify width={16} height={16} icon={'eva:plus-fill'} />
                                                </Box>
                                                <Typography
                                                    component={'p'}
                                                    onClick={(e) => OpenAssignTask(upComingData, e)}
                                                    sx={{ ...unassignTypo, color: isLight ? grey[700] : grey[500] }}
                                                >Unassigned</Typography>
                                            </Box>}
                                    </Box>
                                </Box>
                            </Paper>
                        </Box>
                        {leadReminder?.count > 1 && <Button sx={{ mt: '5px' }} onClick={() => onChangeTab('', 'Tasks')}>
                            ...See more
                        </Button>}
                    </Card>}
                    {leadDetail?.lead_treatments?.length > 0 && <Card sx={{ ...appointmentCardStyle, borderRadius: 2, boxShadow: 'none', border: '1px solid', borderColor: 'divider', p: 2, mb: 3 }}>
                        <UpcomingAppointmentsOverview leadAppointment={leadAppointment} treatmentData={treatmentData} leadDetail={leadDetail} treatments={leadDetail?.lead_treatments} handleReloadAPI={handleReloadAPI} />
                    </Card>}
                    {leadDetail?.lead_treatments?.length > 0 && <Card sx={{ ...appointmentCardStyle, borderRadius: 2, boxShadow: 'none', border: '1px solid', borderColor: 'divider', p: 2, mb: 3 }}>
                        <AttendedAppointmentsOverview leadAppointment={pastAppointment} treatmentData={treatmentData} leadDetail={leadDetail} treatments={leadDetail?.lead_treatments} />
                    </Card>}
                    {/* V2 Attended Checklist — replaces the V1 inline checklist surface.
                        The component self-gates visibility (lead has CONSULTATION_ATTENDED
                        treatment AND a V2 task with applies_to_statuses including
                        CONSULTATION_ATTENDED has cells). Returns null otherwise. */}
                    <AttendedChecklistV2
                        practiceId={practiceId}
                        leadId={leadDetail?.id}
                        leadDetail={leadDetail}
                    />
                    {shouldRenderClinCheck && <Card sx={{ ...appointmentCardStyle, borderRadius: 2, boxShadow: 'none', border: '1px solid', borderColor: 'divider', p: 2, mb: 3 }}>
                        <ClinCheckOverViewTab leadDetail={leadDetail} onChangeTab={onChangeTab} />
                    </Card>}
                </Box>}
                <Box sx={(upComingData || leadDetail?.lead_treatments?.length > 0) ? overviewRightLayoutBoxStyle : { width: '100%' }}>
                    {bookedLeadAppointment?.length > 0 && <BookedPaymentStatusCard
                        leadDetail={leadDetail}
                        bookedLeadAppointment={bookedLeadAppointment}
                        bookedTreatment={leadDetail?.lead_treatments?.find(
                            (t) => String(t.id) === String(bookedLeadAppointment?.[0]?.lead_treatment)
                        ) || activeTreatment}
                        practiceId={practiceId}
                        handleMenuItems={handleMenuItems}
                        onChangeTab={onChangeTab}
                    />}
                    <Card sx={{ p: 2, mb: 3, borderRadius: 2, border: '1px solid', borderColor: 'divider', boxShadow: 'none' }}>
                        <RecentNotes leadDetail={leadDetail} LeadNotes={LeadNotes} />
                    </Card>
                    <Card sx={{ p: 2, display: 'flex', mb: 3, borderRadius: 2, border: '1px solid', borderColor: 'divider', boxShadow: 'none' }}>
                        <Box sx={{ p: 0, bgcolor: 'transparent', width: '100%' }}>
                            <NormalLoading tableData={!activityList && 'No Found'} pageCount={!activityList && 'No Found'} />
                            <Typography sx={sectionTitle}>
                                Timeline
                            </Typography>
                            {/* Filter pills */}
                            <Box sx={timelineFilterWrapper}>
                                {['All', 'System', 'Notes', 'Communication'].map((filterLabel) => (
                                    <Box
                                        key={filterLabel}
                                        sx={timelineFilterChip(timelineFilter === filterLabel)}
                                        onClick={() => setTimelineFilter(filterLabel)}
                                    >
                                        {filterLabel}
                                    </Box>
                                ))}
                            </Box>
                            <Box sx={{ maxHeight: '280px', overflow: 'auto', width: '100%' }}>
                                {(filteredActivities || []).slice(0, 3).map((value, index, arr) => {
                                    const { icon: dotIcon, color: dotColor } = getOverviewActivityIcon(value);
                                    const status = getOverviewEmailStatus(value) || getOverviewWhatsAppStatus(value);
                                    const isLast = index === arr.length - 1;
                                    const isCall = isTimelineCall(value);
                                    const rawTitle = value?.data?.data?.message || '';
                                    // A call reads as on the Timeline tab (direction, outcome, duration), not the stored message.
                                    const title = isCall || value?.verb === 'call_logged' ? getActivityTitle(value) : (rawTitle === 'Awaiting Response.' ? 'Awaiting Reply.' : capitalizeFirstLetter(rawTitle));
                                    const dateStr = formatOverviewActivityTime(value.timestamp);
                                    // A call's actor is a fallback; name the person on the call, nobody for a missed inbound call.
                                    const actorName = callActorName(value);
                                    const additionalNotes = value?.action_object?.additional_notes;
                                    return (
                                        <Box
                                            key={`activity-preview-${index}`}
                                            sx={{
                                                position: 'relative',
                                                display: 'flex',
                                                pb: isLast ? 0 : 1.75,
                                            }}
                                        >
                                            {!isLast && (
                                                <Box sx={{
                                                    position: 'absolute',
                                                    left: 13,
                                                    top: 30,
                                                    bottom: 0,
                                                    width: '1px',
                                                    bgcolor: 'rgba(145,158,171,0.16)',
                                                }} />
                                            )}
                                            <Box sx={{
                                                width: 28,
                                                height: 28,
                                                borderRadius: '50%',
                                                bgcolor: `${dotColor}1F`,
                                                flexShrink: 0,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                position: 'relative',
                                                zIndex: 1,
                                                mt: '1px',
                                            }}>
                                                <Iconify icon={dotIcon} sx={{ width: 14, height: 14, color: dotColor }} />
                                            </Box>
                                            <Box sx={{ flex: 1, minWidth: 0, ml: 1.5, pt: 0.25 }}>
                                                <Stack direction='row' alignItems='flex-start' spacing={1}>
                                                    <Typography sx={{
                                                        flex: 1,
                                                        minWidth: 0,
                                                        fontSize: '12px',
                                                        fontWeight: 500,
                                                        color: 'text.primary',
                                                        lineHeight: 1.45,
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                    }}>
                                                        {title || '—'}
                                                    </Typography>
                                                    {status && (
                                                        <Tooltip title={buildOverviewStatusTooltip(status)} placement='left' TransitionComponent={Zoom} TransitionProps={{ timeout: 200 }}>
                                                            <Box sx={{
                                                                display: 'inline-flex',
                                                                alignItems: 'center',
                                                                gap: 0.375,
                                                                px: 0.75,
                                                                py: 0.125,
                                                                borderRadius: 0.625,
                                                                bgcolor: `${status.color}14`,
                                                                flexShrink: 0,
                                                            }}>
                                                                <Iconify icon={status.icon} sx={{ width: 11, height: 11, color: status.color }} />
                                                                <Typography sx={{
                                                                    fontSize: '0.65rem',
                                                                    fontWeight: 600,
                                                                    color: status.color,
                                                                    lineHeight: 1,
                                                                    whiteSpace: 'nowrap',
                                                                }}>
                                                                    {status.label}
                                                                </Typography>
                                                            </Box>
                                                        </Tooltip>
                                                    )}
                                                </Stack>
                                                <Stack direction='row' alignItems='center' spacing={0.75} sx={{ mt: 0.5, flexWrap: 'wrap', rowGap: 0.25 }}>
                                                    {actorName && (
                                                        <Stack direction='row' alignItems='center' spacing={0.5}>
                                                            <CustomAvatar
                                                                src={value?.actor?.avatar || GetPracticeAvatar(practiceTreatment, practiceId)[0]?.logo}
                                                                name={value?.actor?.first_name}
                                                                sx={{ width: 16, height: 16, fontSize: '0.55rem' }}
                                                            />
                                                            <Typography sx={{ fontSize: '0.65rem', color: 'text.secondary', fontWeight: 500 }}>
                                                                {actorName}
                                                            </Typography>
                                                        </Stack>
                                                    )}
                                                    {actorName && dateStr && (
                                                        <Box sx={{ width: 2, height: 2, bgcolor: 'text.disabled', borderRadius: '50%' }} />
                                                    )}
                                                    {dateStr && (
                                                        <Typography sx={{ fontSize: '0.65rem', color: 'text.disabled', fontWeight: 500 }}>
                                                            {dateStr}
                                                        </Typography>
                                                    )}
                                                    {additionalNotes && (
                                                        <>
                                                            <Box sx={{ width: 2, height: 2, bgcolor: 'text.disabled', borderRadius: '50%' }} />
                                                            <Tooltip
                                                                title={getNoteDisplayText(additionalNotes)}
                                                                placement='bottom'
                                                                TransitionComponent={Zoom}
                                                                TransitionProps={{ timeout: 200 }}
                                                            >
                                                                <Typography
                                                                    tabIndex={0}
                                                                    aria-label={`Note: ${getNoteDisplayText(additionalNotes)}`}
                                                                    sx={{
                                                                        fontSize: '0.65rem',
                                                                        color: 'text.secondary',
                                                                        fontStyle: 'italic',
                                                                        fontWeight: 500,
                                                                        maxWidth: 160,
                                                                        whiteSpace: 'nowrap',
                                                                        overflow: 'hidden',
                                                                        textOverflow: 'ellipsis',
                                                                        outline: 'none',
                                                                        '&:focus-visible': {
                                                                            boxShadow: '0 0 0 2px rgba(24,144,255,0.25)',
                                                                            borderRadius: '4px',
                                                                        },
                                                                    }}
                                                                >
                                                                    {parseAINote(additionalNotes) ? '🤖 AI Summary' : `“${capitalizeFirstLetter(additionalNotes).slice(0, 50)}${additionalNotes.length > 50 ? '…' : ''}”`}
                                                                </Typography>
                                                            </Tooltip>
                                                        </>
                                                    )}
                                                </Stack>
                                                {isCall && <TimelineCallEntry act={value} practiceId={practiceId} showDetails />}
                                            </Box>
                                        </Box>
                                    );
                                })}
                                {filteredActivities?.length > 3 && (
                                    <Button sx={{ mt: 1, fontSize: '0.75rem' }} onClick={() => onChangeTab('', 'Timeline')}>
                                        See all activity
                                    </Button>
                                )}
                            </Box>
                        </Box>
                    </Card>
                </Box>
            </Box>
            <Popper
                sx={{
                    zIndex: 1,
                    margin: '0px 20px !important',
                }}
                open={open}
                anchorEl={anchorRef}
                role={undefined}
                transition
                placement={isDesktop ? 'top' : 'top'}
            >
                {({ TransitionProps }) => (
                    <Grow
                        {...TransitionProps}
                    >
                        <Paper>
                            <ClickAwayListener onClickAway={buttonHandleClose} >
                                <MenuList id='split-button-menu' autoFocusItem sx={menuListStyle}>
                                    <MenuItem
                                        key='Attended'
                                        onClick={handleAttenedClick}
                                        sx={overViewMenuItemStyle}
                                    >
                                        <Iconify style={menuItemIcon} width={20} height={20} icon={'akar-icons:check'} /> Attended
                                    </MenuItem>
                                    <MenuItem
                                        key='Failed to attend'
                                        onClick={handleAttenedFailedClick}
                                        sx={overViewMenuItemStyle}
                                    >
                                        <Iconify style={menuItemIcon} width={20} height={20} icon={'ci:close-big'} /> Failed to attend
                                    </MenuItem>
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
            <Dialog open={treatmentCon || cancelTreatment} onClose={popupClose}>
                <DialogTitle sx={{ padding: '40px 40px 0px', textAlign: 'center' }}>Are you sure you want to {treatmentCon ? 'complete the treatment' : 'cancel the treatment'} ?</DialogTitle>
                <DialogActions sx={{ padding: '40px !important', justifyContent: 'center' }}>
                    <Button sx={cancelBtnStyle} onClick={popupClose} >Cancel</Button>
                    <LoadingButton
                        type='submit'
                        variant='contained'
                        loading={isLoader}
                        loadingPosition='start'
                        onClick={apiHandler}
                        sx={{ ...yesBtnStyleForLoader(isLoader) }}
                        disabled={isLoader}
                    >
                        {treatmentCon ? 'Complete treatment' : 'Cancel treatment'}
                    </LoadingButton>
                </DialogActions>
            </Dialog>
            {/* Treatment-in-progress hub — opened by Next step → Open task for a
                TREATMENT_STARTED lead (same popup as the task sidebar's Follow-up). */}
            {openTreatmentHub && (
                <CompletedTreatmentHub
                    open={openTreatmentHub}
                    handleClose={closeTreatmentHub}
                    handleYes={handleTreatmentHubYes}
                    row={hubRow}
                    practiceId={practiceId}
                    isLoader={isLoader}
                />
            )}
            {openAssignTask && (
                <ClickAwayListener onClickAway={onClickAwayEvent}>
                    <Popper open={openAssignTask} anchorEl={anchorElAssign} transition placement='bottom' sx={{ zIndex: '999999' }}>
                        {({ TransitionProps }) => (
                            <Grow {...TransitionProps}>
                                <Paper sx={{ borderRadius: 2 }}>
                                    <AssignTaskPopup
                                        open={openAssignTask}
                                        onClose={popupClose}
                                        leadDetail={leadDetail}
                                        reminder={reminderId}
                                        assignees={assigneeData?.map((ele) => ele.id)}
                                    />
                                </Paper>
                            </Grow>
                        )}
                    </Popper>
                </ClickAwayListener>
            )}
            {openFollowLead && <BookingContactPopup
                        {...pmsBookingSession.navigationProps}
                        recoveryContent={<PmsBookingRecovery session={pmsBookingSession} practiceId={practiceId} onRetry={() => setPmsSlot(null)} onFound={() => handleClose('finish')} />}
                open={openFollowLead}
                headerButtons
                onClose={handleClose}
                openArchivePopup={onOpenArchiveLead}
                debugSource={contactDebugSource}
                user={leadData}
                leadDetail={leadDetail}
                leadTreatmentId={currentTreatmentData?.treatmentData?.id ?? currentTreatmentData?.treatment_id ?? null}
                practiceId={practiceId}
                steps={leadStep}
                type={'followup'}
                validStep={validStep}
                BookingAttendance={BookingAttendance}
                updateStep={() => setValidStep(!validStep)}
                inputRef={inputRef}
                active={active}
                CreateLeadHeaderData={CreateLeadHeaderData}
                setActive={setActive}
                handleReloadLeads={handleReloadLeads}
                ContactedCount={(activeTreatment || leadDetail?.lead_treatments?.[0])?.lead_contacted_counts?.find(item => item.status === (activeTreatment || leadDetail?.lead_treatments?.[0])?.status)?.count || 0}
                setOpenContactFromCall={setOpenContactFromCall}
                showWhatsapp={openContactWhatsapp?.open ? {
                    windowDimension: { width, height },
                    chatScreenData: {
                        name: `${leadDetail?.first_name} ${leadDetail?.last_name}`,
                        phoneNumber: leadDetail?.lead_contact?.phone ?? '',
                        leadId: leadDetail?.id
                    },
                    setChatScreenData: () => { },
                    triggeredFromGrid: true
                } : null}
            />
            }
            {openConsultationAttend && <OpenConsultationPopup
                open={openConsultationAttend}
                headerButtons
                onClose={handleClose}
                user={leadData}
                type={'consultationAttended'}
                inputRef={inputRef}
                CreateLeadHeaderData={CreateLeadHeaderData}
                OpenAssignTask={openAppointmentAssignTaskFuc}
                editDetailHandler={editDetailHandler}
                selectedTreatmentData={currentTreatmentData}
            />
            }
            {openRecordAttend && <OpenAttendedPopup
                open={openRecordAttend}
                headerButtons
                onClose={handleClose}
                user={leadData}
                type={'recordAttended'}
                inputRef={inputRef}
                CreateLeadHeaderData={CreateLeadHeaderData}
                OpenAssignTask={openAppointmentAssignTaskFuc}
                editDetailHandler={editDetailHandler}
                handleNoAttended={(selection) => { setAppointmentOutcomeSelection(selection); dispatch(updateFollowUpLead('recordUnAttended')); onCloseRecordAttend(); onOpenUnRecordAttend(); }}
                isOverview
            />
            }
            {openUnRecordAttend && <OpenUnAttendedPopup
                appointmentSelection={appointmentOutcomeSelection}
                open={openUnRecordAttend}
                headerButtons
                onClose={handleClose}
                user={leadData}
                type={'recordUnAttended'}
                inputRef={inputRef}
                CreateLeadHeaderData={CreateLeadHeaderData}
            />
            }
            {openArchiveLead && <ArchivedLeadPopUp
                open={openArchiveLead}
                headerButtons
                onClose={handleArchivedClose}
                user={leadData}
                type={'archiveLead'}
                inputRef={inputRef}
                CreateLeadHeaderData={CreateLeadHeaderData}
                onExplicitArchiveSubmit={handleExplicitArchiveSubmit}
            />
            }
            {openAppointmentAssignTask && (
                <ClickAwayListener onClickAway={() => appointmentClickAwayEvent()}>
                    <Popper open={openAppointmentAssignTask} anchorEl={anchorElAssign} transition placement='bottom' sx={{ zIndex: '999999' }}>
                        {({ TransitionProps }) => (
                            <Grow {...TransitionProps}>
                                <Paper sx={{ borderRadius: 2 }}>
                                    <AppointmentAssignTaskPopup
                                        open={openAppointmentAssignTask}
                                        onClose={handleCloseAppointmentAssignee}
                                        user={leadData}
                                        leadId={leadDetail?.id}
                                        type={'leadAssign'}
                                        leadDetail={leadDetail}
                                        reminder={reminderId}
                                        selectedTreatmentData={currentTreatmentData}
                                        assignees={assignees}
                                    />
                                </Paper>
                            </Grow>
                        )}
                    </Popper>
                </ClickAwayListener>
            )}
            {leadDetailModal &&
                <EditPersonalDetailsPopup
                    open={leadDetailModal}
                    handleClose={closeEditDetails}
                    selectedRow={leadData}
                    type={'editLead'}
                    inputRef={personalDetailPopupRef}
                    title='Edit Details'
                    headerButtons
                />
            }
            {EditTreatment && (
                <TreatmentEditPopover
                    handleReloadAPI={handleReloadAPI}
                    open={EditTreatment}
                    anchorEl={anchorEditTreatment}
                    handleClickAwayLister={handleClickAwayLister}
                    leadId={leadDetail.id}
                    isAddTreatment
                />
            )}
            {templateOpen && (
                <LeadTemplate
                    openEmailCompose={Boolean(templateOpen)}
                    onCloseEmailCompose={handleCloseEmailCompose}
                    practiceId={practiceId}
                    type={'EMAIL'}
                    leadDetail={leadData}
                />
            )}
            <ReusableSidebar
                type='Task-overView'
                getReminderBtn={getReminderBtn}
                overViewbtns={getReminderBtn}
                handleAttendClick={handleAttenedClick}
                handleAttendFailedClick={handleAttenedFailedClick}
                onClose={sidebarCloser}
                data={reminderData}
                open={openSidebar}
            />
            {/* Superadmin-only debug overlay — self-gated on user.is_superuser.
                Surfaces activeTreatment (the bleed-bug vector) and next-step routing state
                so multi-treatment issues can be diagnosed from a screenshot. */}
            <ContactPopupDebugBox
                popup="LeadDetail-Overview"
                debugSource="overview"
                practiceId={practiceId}
                leadId={leadDetail?.id}
                extra={{
                    leadStatus: leadDetail?.status,
                    activeTreatment: (() => {
                        const td = currentTreatmentDataGlobal?.treatmentData;
                        if (!td) return null;
                        return { id: td.id, treatment: td.treatment, status: td.status, price: td.custom_price ?? td.price };
                    })(),
                    treatments: leadDetail?.lead_treatments?.map((t) => ({ id: t.id, treatment: t.treatment || t.treatment_name, status: t.status, price: t.custom_price ?? t.price })),
                    nextStepSuggestions: (() => { try { return getNextStepSuggestions()?.map((s) => ({ treatmentId: s.treatment?.id, treatmentStatus: s.treatment?.status, cta: s.cta, action: s.action, message: s.message })); } catch (e) { return null; } })(),
                    currentTreatmentDataLocal: currentTreatmentData,
                }}
            />
        </Stack >
    );
};

Overview.propTypes = {
    leadDetail: PropTypes.object,
    activityList: PropTypes.array,
    onChangeTab: PropTypes.func,
    reloadTaskCounter: PropTypes.func,
    handleLoading: PropTypes.func,
    LeadNotes: PropTypes.array,
    handleMenuItems: PropTypes.func,
    setSelectTreatmentData: PropTypes.object,
    openContactFromCall: PropTypes.bool,
    setOpenContactFromCall: PropTypes.func,
    autoAction: PropTypes.string,
    handleReloadLeads: PropTypes.func,
};

export default Overview;
